import { HttpParams } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  inject,
  HostListener
} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import { camelCase, cloneDeep, debounce, filter, isEqual, sortBy } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { FilterService, MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, Subscription, distinctUntilChanged, forkJoin, fromEvent, map } from 'rxjs';
import * as propertyActions from 'src/app/STORE/actions/propertypane.actions';
import { setScreenValues, setSelectedLKTbl } from 'src/app/STORE/actions/propertypane.actions';
import { getFieldsInfoForTable, setFieldsInfoForTable } from 'src/app/STORE/actions/screens.actions';
import {
  allAppFromSuiteList,
  appData,
  memAppList,
  selectedAppData
} from 'src/app/STORE/selectors/applifecycle.selector';
import { userData } from 'src/app/STORE/selectors/auth.selector';
import { foreignKeyTbl, lookUpTables } from 'src/app/STORE/selectors/datamodel.selector';
import {
  curNodeData,
  lookupFields,
  mandatoryFilters,
  parentNodeType,
  picklist,
  propLoading,
  propertiesBasicData,
  propertiesData,
  propertiesType,
  propertiesValues,
  screenValues,
  tabMapFlds,
  tableNames
} from 'src/app/STORE/selectors/propertypane.selector';
import { currentPage } from 'src/app/STORE/selectors/router.selector';
import {
  allIdMaps,
  allScreens,
  fiForSelectedScreen,
  queryTableData,
  queryTables,
  msScreenData
} from 'src/app/STORE/selectors/screens.selector';
import {
  appSettingsData,
  environmentDataList,
  technologystackData
} from 'src/app/STORE/selectors/technologystack.selector';
import { dynamicPossibleOptions, dynamicPossibleOptionsForHide } from 'src/app/STORE/selectors/workflow.selector';
import { consumedAPIByProvider } from 'src/app/STORE/selectors/consumedrest.selector';
import { allInterimScreens } from 'src/app/STORE/selectors/generations/screen-interim.selectors';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { DMConstants, nodeType } from 'src/app/pages/designs/data-model/data-model.component';
import { pageTableType } from 'src/app/pages/prototyping/screens/screens.component';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UploadAttachmentService } from 'src/app/services/upload-attachment.service';
import { ApplicationTypes, DefaultFields } from 'src/app/services/util.enum';
import {
  UtilService,
  validateUrl,
  getUrlValidationErrorMessage,
  validatePojoNamesNotSame,
  validatePojoNamesUnique
} from 'src/app/services/util.service';
import icons from 'src/assets/sampleData/fontawesome.icons.json';
import { environment } from 'src/environments/environment';
import { FontComponent } from '../font/font.component';
import { PickupListService } from '../pickup-list/pickup-list.service';
import { PreValidationTblViewComponent } from '../pre-validation-tbl-view/pre-validation-tbl-view.component';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { getTechnologyStack, getTechnologyStackBySuiteId } from 'src/app/STORE/actions/technologystack.actions';
import { ReferenceUtilService } from '../reference-tree-view/reference-util.service';
import { ChangeDetectorRef } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { PropertyPaneService } from './property-pane.util';
import { ActionType, ModelType, UiActions } from '../reference-tree-view/reference.enum';
import { MergeStatusService } from 'src/app/services/merge-status.service';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { TooltipWatchdogService } from 'src/app/services/tooltip-watchdog.service';
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-properties-pane',
  templateUrl: './properties-pane.component.html',
  styleUrls: ['./properties-pane.component.scss'],
  standalone: false //NOSONAR
})
export class PropertiesPaneComponent implements OnInit, OnChanges, OnDestroy {
  private store = inject(Store);
  private filterService = inject(FilterService);
  private uploadService = inject(UploadAttachmentService);
  private appGlobalService = inject(AppGlobalService);
  private referenceUtil = inject(ReferenceUtilService);
  private loader = inject(AppLoaderService);
  private baseService = inject(HttpBaseService);
  private messageService = inject(MessageService);
  private readonly mergeStatusService = inject(MergeStatusService);
  private zone = inject(NgZone);
  private bs = inject(HttpBaseService);
  private util = inject(UtilService);
  private translate = inject(TranslateService);
  private confirmationDialogService = inject(ConfirmationDialogService);
  private pickupListService = inject(PickupListService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly propertyPaneService = inject(PropertyPaneService);
  private dialogService = inject(DialogService);
  private readonly tooltipWatchdog = inject(TooltipWatchdogService);

  @Input() propertiesData: any = null;
  @Input() currentScreen: any;
  @Input() currentTable: any;
  @Input() currentPicklist: any;
  @Input() pageName: any;
  @Input() fsData: any;
  @Input() currentSelectedTreeNode: any;
  @Input() selectedPropertyTitle: any;
  @Input() seletedTemplate: any = null;
  @ViewChild('imageElement') imageElement: ElementRef;
  @ViewChild('pwaElement') pwaElement: ElementRef;

  @ViewChildren(Tooltip)
  set tooltips(value: QueryList<Tooltip>) {
    this._tooltips = value;
    if (value && value.length > 0) {
      this.tooltipWatchdog.registerTooltips(value);
    }
  }
  get tooltips(): QueryList<Tooltip> {
    return this._tooltips;
  }
  private _tooltips: QueryList<Tooltip>;

  @HostListener('window:mousedown', ['$event'])
  onWindowClick(event: MouseEvent) {
    this.tooltipWatchdog.hideAllTooltips();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.tooltipWatchdog.hideAllTooltips();
  }

  @HostListener('mouseover', ['$event'])
  onMouseOverAction(event: MouseEvent) {
    this.tooltipWatchdog.handleMouseOver(event);
  }

  subscriptions: Subscription[] = [];
  dataSetJson: any[] = [];
  currentFieldType: any;
  showRefPopup = true;
  isEditable = false;
  searchableFields: any[] = [];
  groupedLookUpTables: any[] = [];
  defaultFieldsArray: any[] = [
    DefaultFields.CREATED_BY,
    DefaultFields.CREATED_DATE,
    DefaultFields.MODIFIED_BY,
    DefaultFields.MODIFIED_DATE
  ];
  applicationType: any;
  queryViewArray = [
    'f_formula',
    'f_multiValMin',
    'f_multiValMax',
    'f_hasMultiVal',
    'f_notAllowedFTypes',
    'f_allowedFTypes',
    'f_minA',
    'f_maxA',
    'f_maxASize',
    'f_aNType',
    'f_hasAnalyticalSync',
    'f_inputMask',
    'f_transientField'
  ];
  propertyPaneBasicData$: Observable<any> = this.store.select(propertiesBasicData);
  propertyPaneValues$: Observable<any> = this.store.select(propertiesValues);
  propertiesData$: Observable<any> = this.store.select(propertiesData);
  screenValues$: Observable<any> = this.store.select(screenValues);
  tableNames$: Observable<any> = this.store.select(tableNames);
  lookupFields$: Observable<any> = this.store.select(lookupFields);
  environmentDataList$: Observable<any> = this.store.select(environmentDataList);
  dynamicPossibleOptions$: Observable<any> = this.store.select(dynamicPossibleOptions);
  dynamicPossibleOptionsForHide$: Observable<any> = this.store.select(dynamicPossibleOptionsForHide);
  propertiesType$: Observable<any> = this.store.select(propertiesType);
  consumedAPIByProvider$: Observable<any> = this.store.select(consumedAPIByProvider);
  consumedAPIData: any[] = [];
  isQueryTable = false;
  nodeChildren$: Observable<any> = this.store.select(curNodeData);
  @Input() actorsData: any = null;
  @Input() fields: any = null;
  @Input() curNode: any = null;
  @Input() selectedNodeType: any = null;
  @Output() public readonly templateValueChange = new EventEmitter();
  isLoadingProps = false;
  formGroup: FormGroup = new FormGroup({});
  imagePresent = false;
  pwaImagePresent = false;
  disallowForReference = false;
  formInfo: any = {};
  formData: any = null;
  val: any = {};
  sharedDbId: any;
  resetFormData = false;
  query: any = null;
  dataSetMap = new Map<string, string>();
  queryBuilderPropertyName: any = null;
  faIcons: any[] = [];
  fieldMap: any = {};
  ref$: Subscription = new Subscription();
  currentSelectedNode: any = null;
  filteredLookup: any[] = [];
  currentClickedField: any = null;
  formSub: Subscription;
  private isProcessingValueChange = false;
  initialLoading = false;
  allowRuleset = true;
  allowCollapse = true;
  isBetaAccessPrivilegeConsumable = false;
  selectedLookUp: any = '';
  files: any = [];
  orgId: string;
  appId: string;
  allProperties: any = null;
  tableNames: any = null;
  results: any = null;
  currentNode: any = null;
  currentPage: any = null;
  allRoles: any = [];
  queryCheck = false;
  selectedGroup: any;
  fromDataModel = false;
  currNodeType: any = null;
  queryBuilderName = null;
  hideElements = {};
  allScreens: any = [];
  formDefaultValues: any = {};
  title: any = 'Title';
  currentScreenId = '';
  allFields: any = null;
  searchFields: any = null;
  defaultValues: any = {};
  environments: any = [];
  filteredEnvironmentsForDialog: any[] = [];
  showEnvUrlConfigDialog = false;
  envFormDataCache: Record<string, string> = {};
  searchTerm: any;
  mergedDefaultValues = {};
  servivcesList: any = [];
  formFieldSub: any;
  transientFieldSub: any;
  fieldIdMap: any;
  tableIdMap: any;
  imageLoading: any;
  filteredDefaultValues: any = {};
  allProps: any = {};
  conditions: any = {};
  conditionalCheck: any = {};
  conditionCheckGp: any = {};
  transactionalDB: string;
  workflowDynamicOptions = {
    Fields: [],
    Actions: []
  };
  screenDynamicOptions = {
    Fields: []
  };
  menuItems: MenuItem[];
  qryTable: any[] = [];
  showRdbmsProps = false;
  additionalCondCheck: any = {};
  pickList: any;
  datasets: any[] = [];
  @ViewChildren('fontComponentRef') fontComponents: QueryList<FontComponent>;
  currentpropertiesValues: any;
  @Input() dataModelOrders: any = null;
  disallowEdit = false;
  disabledRadioOptions: Record<string, string[]> = {};
  betaRadioOptionsMap: Record<string, { label: string; value: any; disabled: boolean }[]> = {};
  betaExpandedGroups: string[] = [];

  @Input() isFromModernize = false;
  /** Returns true if fields should be disabled for modernize mode on list pages */
  get modernizeListDisabled(): boolean {
    return (
      this.isFromModernize &&
      this.currentScreen?.pageType !== 'detail' &&
      this.currentScreen?.pageType !== 'appNavigation'
    );
  }

  getBetaExpandedGroupValues(properties: any[]): string[] {
    if (!Array.isArray(properties)) {
      return [];
    }

    return properties
      .filter((property: any) => property?.type === 'group' && property?.groupName)
      .map((property: any) => property.groupName);
  }

  onBetaAccordionValueChange(value: any): void {
    if (Array.isArray(value)) {
      this.betaExpandedGroups = value as string[];
      return;
    }

    this.betaExpandedGroups = value ? [value] : [];
  }

  private getDefaultButtonConfirmationText(buttonData: any): string | null {
    if (buttonData?.action === 'delete') {
      return this.translate.instant('DELETE_SELECTED_RECORDS_CONFIRMATION');
    }
    if (buttonData?.action === 'cancel') {
      return this.translate.instant('DISCARD_UNSAVED_CHANGES_CONFIRMATION');
    }
    if (buttonData?.action === 'call_a_backend_webservice' && buttonData?.wfAction) {
      return this.translate.instant('WORKFLOW_ACTION_RECORD_CONFIRMATION', { action: buttonData.wfAction });
    }
    return null;
  }

  private applyButtonConfirmationDefaults(buttonData: any, previousButtonData?: any): void {
    const nextDefaultText = this.getDefaultButtonConfirmationText(buttonData);
    const previousDefaultText = this.getDefaultButtonConfirmationText(previousButtonData);

    if (nextDefaultText) {
      buttonData.beforeAction = 'show_confirmation';
      if (!buttonData.confirmationText || buttonData.confirmationText === previousDefaultText) {
        buttonData.confirmationText = nextDefaultText;
      }
      return;
    }

    buttonData.beforeAction = buttonData.beforeAction ? buttonData.beforeAction : 'none';
  }

  /** Editable properties per node type for detail pages in modernize mode. Empty array = all readonly. */
  private static readonly MODERNIZE_DETAIL_EDITABLE: Record<string, string[]> = {
    button: ['label', 'buttonEnabled', 'visibility', 'styleClass'],
    buttongroup: ['displayCount', 'styleClass'],
    captionitem: ['label', 'showOn', 'displayAsToggleSwitch', 'styleClass'],
    form: ['columns', 'accordionOnFormSection', 'styleClass'],
    formfield: ['label', 'styleClass'],
    formsection: ['label', 'columns', 'hideSectionHeading', 'styleClass'],
    tabview: ['styleClass'],
    tab: ['label', 'columns', 'styleClass'],
    standarddatagrid: ['hideListPageTitle', 'childPageLimit', 'styleClass'],
    childlist: ['hideListPageTitle', 'childPageLimit', 'styleClass'],
    custombutton: ['label', 'styleClass']
  };

  /** Returns true if the given property should be disabled in modernize mode */
  isModernizeDisabled(propertyName?: string): boolean {
    if (!this.isFromModernize) {
      return false;
    }
    if (this.currentScreen?.pageType === 'detail') {
      const nodeType = this.currNodeType?.toLowerCase();
      const editableProps = (nodeType && PropertiesPaneComponent.MODERNIZE_DETAIL_EDITABLE[nodeType]) ?? ['label'];
      return !editableProps.includes(propertyName);
    }
    if (this.currentScreen?.pageType === 'appNavigation') {
      return !(this.currNodeType?.toLowerCase() === 'menuitem'
        && (propertyName === 'label' || propertyName?.toLowerCase() === 'page'));
    }
    return true;
  }

  apiDatastart = 0;
  totalRecords = 0;
  @Input() iconSize = '13px';
  lookupTblProps: any = null;
  techStackData: any = null;
  settingsData: any = null;
  parentNodeTableType: any = '';
  refTableNames: any[] = [];
  drpSearchTxt = '';
  primarkeyMsg = '';
  lCodeInfo =
    'Code of default language selected in translation which is used as a default selected language for generated app';
  memberScreensData: any = null;
  private consumedRestTimeoutId: ReturnType<typeof setTimeout> | null = null;
  hideBasic = false;
  isMicroserviceSuite = false;
  suiteId: any;
  textSearch = '';
  isBusinessRulesEnabled = false;
  msApps: any[] = [];
  private previousAppIdForConsumers: string | null = null;
  tableInfo: {
    currentTableForeignKeys?: any[];
    currentTableIndexList?: any[];
    currentTableSearchableField?: {
      fields: any[];
      foreignKeyFields?: any[];
    };
    foreignTableFields?: any[];
  } = {};

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  filterIcons(e: any) {
    const filtered = [...icons].filter((ic: any) => {
      return ic.label.indexOf(e.query) > -1;
    });
    this.faIcons = filtered;
  }

  createImageFromBlob(image: Blob, prop: any) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        const imageToShow: any = reader.result;
        $(`#${prop.name}_img`).attr('src', imageToShow);
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
    this.imageLoading = false;
  }
  setImage(prop, api) {
    if (prop.name === 'urlIcon' || prop.name === 'image') {
      this.imagePresent = true;
    }
    if (prop.name === 'pwaIcon') {
      this.pwaImagePresent = true;
    }
    const downloadSub = this.uploadService.downloadFile(api).subscribe((data: any) => {
      const fileType = this.formData[prop.name]?.icon[0]?.fileName?.split('.')[1];
      let newData = data;
      if (fileType === 'svg') {
        newData = newData.slice(0, newData.size, 'image/svg+xml');
      }
      this.createImageFromBlob(newData, prop);
    });
    this.addToSubscriptionsList(downloadSub);
  }

  getImages() {
    this.imagePresent = false;
    const imgSelectors = ['imageselector', 'pwaimageselector'];
    if (!Array.isArray(this.allProperties)) {
      return;
    }
    this.allProperties.map((prop: any) => {
      if (imgSelectors.indexOf(prop.uiType) > -1) {
        if (this.formData?.[prop.name]?.icon?.length) {
          const file = this.formData[prop.name]?.icon[0]?.id;
          const api = `${ApiConstants.getFileContents.url + file}/${this.appId}`;
          this.imageLoading = true;
          this.setImage(prop, api);
        }
      }
    });
  }

  checkConditionOnValueChange(onValueChange?: boolean) {
    try {
      const conditionalCheck: any = {};
      conditionalCheck.showGroups = !!this.formData;
      const updatedValues = {};
      for (const key in this.conditions) {
        const value = this.conditions[key];
        const length = value?.length;
        if (length > 0) {
          const prop = this.allProperties?.find((p) => p.name === key);
          let conditionMatch = prop?.conditionalOperator !== 'OR';
          if (this.formData) {
            for (let i = 0; i < length; i++) {
              const condition = value[i];
              const fieldVal = this.formData[condition.field];
              if (prop && prop?.conditionalOperator === 'OR') {
                conditionMatch =
                  conditionMatch ||
                  this.checkCondition(
                    condition.operator,
                    fieldVal === undefined || null || '' ? fieldVal : String(fieldVal),
                    condition.value
                  );
              } else {
                conditionMatch =
                  conditionMatch &&
                  this.checkCondition(
                    condition.operator,
                    fieldVal === undefined || null || '' ? fieldVal : String(fieldVal),
                    condition.value
                  );
              }
            }
            if (!conditionMatch && this.formGroup) {
              if (
                (!Array.isArray(this.formData[key]) &&
                  (this.formData[key] || this.formDefaultValues[key]) &&
                  this.formData[key] !== this.formDefaultValues[key]) ||
                (Array.isArray(this.formData[key]) &&
                  JSON.stringify(this.formData[key]) !== JSON.stringify(this.formDefaultValues[key]))
              ) {
                updatedValues[key] = this.formDefaultValues[key];
              }
            }
            conditionalCheck[key] = conditionMatch;
          } else {
            conditionalCheck[key] = false;
          }
        } else {
          conditionalCheck[key] = !!this.formData;
        }
        /**
         * This option is requuired only for the list page buttons
         */
        if (this.currentPage?.currentPage === 'screens' && key === 'enableOnlyIfRecordSelected') {
          if (this.currentScreen?.pageType === 'detail') {
            conditionalCheck[key] = false;
          }
        }
        if (this.currentPage?.currentPage === 'screens' && this.currentScreen?.pageType === 'detail') {
          const detailPageCtrl = this.formGroup?.get('defaultDetailPageEnabled');
          if (detailPageCtrl) {
            if (this.formData?.defaultDetailPageEnabled && !detailPageCtrl.disabled) {
              detailPageCtrl.disable({ onlySelf: true });
            } else if (!this.formData?.defaultDetailPageEnabled && detailPageCtrl.disabled) {
              detailPageCtrl.enable({ onlySelf: true });
            }
          }
          if (this.currNodeType?.toLowerCase() === 'formfield') {
            const currentFieldDetail = this.currentPicklist?.fieldsWithDetails?.find((f) => f?.sid == this.currentNode);

            if (
              currentFieldDetail &&
              (currentFieldDetail.f_editing === 'no' || currentFieldDetail.f_editing === false)
            ) {
              if (this.formGroup?.controls['allowEditing']?.value === 'auto') {
                this.formGroup?.controls['allowEditing']?.disable({ onlySelf: true });
              }
            } else if (!this.disallowEdit) {
              this.formGroup?.controls['allowEditing']?.enable({ onlySelf: true });
            }
          } else if (this.formGroup?.controls['allowEditing'] && this.currNodeType?.toLowerCase() !== 'formfield') {
            if (!this.disallowEdit) {
              this.formGroup?.controls['allowEditing']?.enable({ onlySelf: true });
            }
          }
        }

      }
      if (conditionalCheck.displayAsToggleSwitch) {
        conditionalCheck.displayAsToggleSwitch = false;
      }
      this.currentFieldType =
        this.pickList?.fieldsWithType
          ?.find(
            (fld) =>
              fld.sid === this.currentSelectedTreeNode?.data?.sid ||
              fld.sid === this.currentSelectedTreeNode?.data?.id ||
              fld.name === this.formData?.data
          )
          ?.type?.toLowerCase() || this.currentSelectedTreeNode?.data?.dt?.toLowerCase();
      this.hideToggleCheckBox(conditionalCheck, this.currentFieldType);
      if (this.currentPage?.currentPage === 'screens') {
        if (this.currentScreen?.pageType === 'detail') {
          this.conditionalCheck.visibility = true;
        }
      }
      if (Object.keys(updatedValues).length > 0) {
        this.formGroup?.patchValue(updatedValues);
        this.formGroup?.markAsDirty();
      }
      const pickSub = this.store.select(picklist).subscribe((pickList) => {
        if (pickList) {
          this.pickList = pickList;
          this.currentFieldType =
            this.pickList?.fieldsWithType
              ?.find(
                (fld) =>
                  fld.sid === this.currentSelectedTreeNode?.data?.sid ||
                  fld.sid === this.currentSelectedTreeNode?.data?.id ||
                  fld.name === this.formData?.data
              )
              ?.type?.toLowerCase() || this.currentSelectedTreeNode?.data?.dt?.toLowerCase();
          this.hideToggleCheckBox(this.conditionalCheck, this.currentFieldType);
          if (this.currentFieldType && this.displayAsFieldsHideOrShow(this.currentFieldType)) {
            if (this.conditionalCheck.displayAs) {
              this.conditionalCheck.displayAs = false;
            }
          }
        }
      });
      this.addToSubscriptionsList(pickSub);
      for (const property of this.allProperties ?? []) {
        if (property?.type === 'group') {
          const prpitems = property.items.filter(
            (item) => conditionalCheck[item.name] && !this.additionalCondCheck[item.name]
          );
          this.conditionCheckGp[property.groupName] = !!prpitems.length;
          this.hideBasic = false;
          if (
            this.currentClickedField &&
            (this.currentClickedField.name === 'First Name' ||
              this.currentClickedField.name === 'Email' ||
              this.currentClickedField.name === 'Last Name') &&
            this.currentClickedField.sysGen
          ) {
            this.conditionCheckGp.Multivalue = false;
          } else if (
            this.currentClickedField &&
            this.currentClickedField.name === 'User Roles' &&
            this.currentClickedField.sysGen
          ) {
            this.conditionCheckGp.Mandatory = false;
            this.conditionCheckGp.Length = false;
            this.conditionCheckGp['Character Validation'] = false;
            this.hideBasic = true;
          } else if (this.currentClickedField?.f_type === 'Auto-number') {
            this.hideBasic = true;
          }
          if (
            this.currNodeType?.toLowerCase() === 'grid' &&
            this.currentScreen?.pageTableType === pageTableType.QUERY_VIEW
          ) {
            this.additionalCondCheck.defaultFilter = true;
            this.conditionCheckGp['Filter Properties'] = false;
            this.checkforQueryTblMandFilters();
          } else {
            this.additionalCondCheck.defaultFilter = false;
            this.conditionCheckGp['Filter Properties'] = true;
            this.conditionCheckGp['Parameter Mapping'] = false;
          }

          if (property.groupName === 'Active/Inactive Filter') {
            this.updateActiveFiltersVisibility();
          }
        }
      }
      if (this.queryCheck) {
        this.conditionCheckGp.Technical = false;
        this.conditionCheckGp['Field Value Reference'] = false;
      } else {
        this.conditionCheckGp.Technical = true;
        if (this.currentClickedField?.f_hasFK) {
          this.conditionCheckGp['Field Value Reference'] = false;
        } else {
          this.conditionCheckGp['Field Value Reference'] = true;
        }
      }

      // Restrict Allow editing for system generated field
      if (
        this.currNodeType == 'formField' &&
        this.currentPicklist.fieldsWithDetails?.find((field) => field.sid == this.currentNode)?.f_sysF === true
      ) {
        this.additionalCondCheck.allowEditing = true;
        this.additionalCondCheck.allowEditingCondition = true;
      } else {
        this.additionalCondCheck.allowEditing = false;
        this.additionalCondCheck.allowEditingCondition = false;
      }

      setTimeout(() => {
        this.disableDisplayFilterCheckBox();
        this.hideToggleCheckBox(conditionalCheck, this.currentFieldType);
        this.conditionalCheck = conditionalCheck;
        this.currentFieldType =
          this.pickList?.fieldsWithType
            ?.find(
              (fld) =>
                fld.sid === this.currentSelectedTreeNode?.data?.sid ||
                fld.sid === this.currentSelectedTreeNode?.data?.id ||
                fld.sid === this.formData?.currentNode ||
                fld.name === this.formData?.data
            )
            ?.type?.toLowerCase() || this.currentSelectedTreeNode?.data?.dt?.toLowerCase();
        if (this.currentFieldType && this.displayAsFieldsHideOrShow(this.currentFieldType)) {
          if (this.conditionalCheck.displayAs) {
            this.conditionalCheck.displayAs = false;
          }
        }
        const disableForSysGenMenus =
          this.currentSelectedTreeNode?.data?.sysGen || this.currentSelectedTreeNode?.data?.id === 'import-menu';
        if (disableForSysGenMenus) {
          this.formGroup?.get('onClick')?.disable();
        }
        this.checkForTechnical();
        if (this.currentScreen?.pageType === 'homePage') {
          this.conditionCheckGp['Page Variables'] = false;
          this.conditionalCheck.pageVariablesProperty = false;
        }
        // Apply modernize mode restrictions (hide/disable fields and groups)
        if (this.isFromModernize) {
          const isListPage =
            this.currentScreen?.pageType !== 'detail' && this.currentScreen?.pageType !== 'appNavigation';
          this.propertyPaneService.applyModernizeRestrictions(
            isListPage,
            this.currNodeType,
            this.conditionalCheck,
            this.conditionCheckGp,
            this.formGroup,
            this.allProperties
          );
          // For detail pages in modernize mode, restrict properties based on node type
          if (this.currentScreen?.pageType === 'detail') {
            const nodeType = this.currNodeType?.toLowerCase();
            this.formGroup?.disable();
            if (nodeType === 'button') {
              // Red/editable: label only (buttonEnabled and visibility stay disabled for screen interims)
              this.formGroup?.get('label')?.enable({ onlySelf: true });
            } else if (nodeType === 'buttongroup') {
              // Red/editable: displayCount (Visible Button Count)
              this.formGroup?.get('displayCount')?.enable({ onlySelf: true });
            } else if (nodeType === 'captionitem') {
              // Red/editable: label, showOn, displayAsToggleSwitch
              this.formGroup?.get('label')?.enable({ onlySelf: true });
              this.formGroup?.get('showOn')?.enable({ onlySelf: true });
              this.formGroup?.get('displayAsToggleSwitch')?.enable({ onlySelf: true });
            } else if (nodeType === 'form') {
              // Red/editable: columns, accordionOnFormSection
              this.formGroup?.get('columns')?.enable({ onlySelf: true });
              this.formGroup?.get('accordionOnFormSection')?.enable({ onlySelf: true });
            } else if (nodeType === 'formfield') {
              // Red/editable: label
              this.formGroup?.get('label')?.enable({ onlySelf: true });
            } else if (nodeType === 'formsection') {
              // Red/editable: label, columns, hideSectionHeading
              this.formGroup?.get('label')?.enable({ onlySelf: true });
              this.formGroup?.get('columns')?.enable({ onlySelf: true });
              this.formGroup?.get('hideSectionHeading')?.enable({ onlySelf: true });
            } else if (nodeType === 'tab') {
              // Red/editable: label, columns
              this.formGroup?.get('label')?.enable({ onlySelf: true });
              this.formGroup?.get('columns')?.enable({ onlySelf: true });
            } else if (nodeType === 'standarddatagrid' || nodeType === 'childlist') {
              // Red/editable: hideListPageTitle, childPageLimit
              this.formGroup?.get('hideListPageTitle')?.enable({ onlySelf: true });
              this.formGroup?.get('childPageLimit')?.enable({ onlySelf: true });
            } else if (nodeType !== 'tabview') {
              // For other node types (not tabview), enable label by default
              this.formGroup?.get('label')?.enable({ onlySelf: true });
            }
            // Enable styleClass for all node types in modernize detail mode
            this.formGroup?.get('styleClass')?.enable({ onlySelf: true });
          }
          // For app navigation pages, disable all properties except label and page for menuItem
          if (this.currentScreen?.pageType?.toLowerCase() === 'appnavigation') {
            this.formGroup?.disable();
            const navType = this.currNodeType?.toLowerCase().replace(/_/g, '');
            if (navType === 'menuitem') {
              this.formGroup?.get('label')?.enable({ onlySelf: true });
              this.formGroup?.get('page')?.enable({ onlySelf: true });
              // Always set onClick to navigate_to_page and keep it disabled
              if (!this.formGroup?.get('onClick')?.value) {
                this.formGroup?.get('onClick')?.setValue('navigate_to_page', { emitEvent: false });
              }
              this.formGroup?.get('onClick')?.disable();
              // Ensure formData reflects onClick so conditional visibility resolves correctly
              if (this.formData) {
                this.formData.onClick = this.formGroup?.get('onClick')?.value || 'navigate_to_page';
              }
              // Force page field visible since onClick is navigate_to_page
              this.conditionalCheck.page = true;
            }
            // Enable styleClass for menuItem and menuGroup in appNavigation
            if (navType === 'menuitem' || navType === 'menugroup') {
              this.formGroup?.get('styleClass')?.enable({ onlySelf: true });
            }
            // Enable styleClass for menuItem and menuGroup in appNavigation
            if (navType === 'menuitem' || navType === 'menugroup') {
              this.formGroup?.get('styleClass')?.enable({ onlySelf: true });
            }
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  shouldShowAllowEditingTooltip(property: any): boolean {
    return property.name === 'allowEditing' && !!this.formGroup?.controls['allowEditing']?.disabled;
  }

  getAllowEditingTooltip(property: any): string {
    if (property.name === 'allowEditing' && this.formGroup?.controls['allowEditing']?.disabled) {
      return (
        this.translate.instant('ALLOW_EDITING_DISABLED') ||
        'Allow Editing is disabled because editing is not allowed for this field in the data model'
      );
    }

    return '';
  }


  hideToggleCheckBox(conditionalCheck, fieldType) {
    if (fieldType) {
      if (this.displayAsToggleFieldsHideOrShow(fieldType)) {
        this.conditionalCheck.displayAsToggleSwitch = true;
        conditionalCheck.displayAsToggleSwitch = true;
        if (
          Object.prototype.hasOwnProperty.call(this.formGroup?.controls, 'formatDisplay') &&
          ((this.formGroup?.controls.displayAsToggleSwitch.value && !this.formGroup?.controls.formatDisplay.value) ||
            (!this.formGroup?.controls.displayAsToggleSwitch.value && this.formGroup?.controls.formatDisplay.value))
        ) {
          if (this.formGroup.controls.displayAsToggleSwitch.value) {
            this.formGroup.controls.formatDisplay.disable({ onlySelf: true });
          } else {
            this.formGroup.controls.displayAsToggleSwitch.disable({ onlySelf: true });
          }
        }
      } else {
        conditionalCheck.displayAsToggleSwitch = false;
        this.conditionalCheck.displayAsToggleSwitch = false;
      }
    }
  }

  disableDisplayFilterCheckBox() {
    if (Object.prototype.hasOwnProperty.call(this.formGroup?.controls, 'viewInPages')) {
      if (this.formGroup?.controls.viewInPages.value) {
        this.formGroup?.controls.editInPages.enable();
      } else {
        this.formGroup?.controls.editInPages.disable();
      }
    }
  }

  checkForTechnical() {
    const checkForTechnical =
      (this.additionalCondCheck.f_hasAnalyticalSync &&
        (this.currentClickedField?.f_hasFK || this.currentClickedField?.f_indexed)) ||
      this.currentClickedField?.f_type === 'File Attachments' ||
      this.currentClickedField?.f_type === 'Auto-number';
    if (checkForTechnical) {
      this.conditionCheckGp.Technical = false;
    }
  }

  displayAsFieldsHideOrShow(fieldType: any) {
    return (
      fieldType !== 'string' &&
      fieldType !== 'dropdown' &&
      fieldType !== 'checkboxgroup' &&
      fieldType !== 'radio' &&
      fieldType !== 'date' &&
      fieldType !== 'datetime' &&
      fieldType !== 'number' &&
      fieldType !== 'double' &&
      fieldType !== 'currency' &&
      fieldType !== 'lookup' &&
      fieldType !== 'auto-number'
    );
  }

  displayAsToggleFieldsHideOrShow(fieldType: any) {
    return fieldType === 'boolean' || fieldType === 'checkbox';
  }

  getKeyByValue(mapValue: Map<string, any>, targetValue: any): string | undefined {
    for (const [key, value] of mapValue.entries()) {
      if (value === targetValue) {
        return key;
      }
    }
    return undefined; // Return undefined if the value is not found in the Map
  }

  dispatchCall() {
    this.appGlobalService.write('transientFieldUpdate', 'false');
    this.store.dispatch(
      propertyActions.setPropertiesValues({ propertiesValues: this.formData, currentScreenId: this.currentScreenId })
    );
    this.checkConditionOnValueChange(); // Have to call this method after formdata is updated
    this.formGroup?.markAsPristine();
  }

  resolveNavigateToPageProperty(propertyName: string) {
    if (!this.isMicroserviceSuite || !this.memberScreensData) {
      return;
    }

    const pageData = this.formData?.[propertyName];
    if (!this.isResolvablePageData(pageData)) {
      return;
    }

    const screenFromAll = this.findScreenInAllScreens(pageData.sid);
    if (screenFromAll) {
      this.formData[propertyName] = this.buildPageData(pageData.sid, screenFromAll, screenFromAll.appId);
      return;
    }

    if (this.isCustomActionButton()) {
      return;
    }

    const memberResult = this.findScreenInMemberApps(pageData.sid);
    if (memberResult) {
      this.formData[propertyName] = this.buildPageData(pageData.sid, memberResult.screen, memberResult.appId);
    }
  }

  private isResolvablePageData(pageData: any): boolean {
    return !!pageData && typeof pageData === 'object' && !!pageData.sid && !pageData.name;
  }

  private findScreenInAllScreens(sid: string): any | null {
    return this.allScreens?.find((s: any) => s.sid === sid) ?? null;
  }

  private findScreenInMemberApps(sid: string): { screen: any; appId: string } | null {
    for (const appId of Object.keys(this.memberScreensData)) {
      const screens = this.memberScreensData[appId];
      if (Array.isArray(screens)) {
        const screen = screens.find((s: any) => s.sid === sid);
        if (screen) {
          return { screen, appId };
        }
      }
    }
    return null;
  }

  private buildPageData(sid: string, screen: any, appId: string): any {
    return {
      sid,
      name: screen.pageName || screen.name,
      appId,
      pageTableType: screen.pageTableType
    };
  }

  isCustomActionButton(): boolean {
    const nodeType = this.currNodeType?.toLowerCase();
    return nodeType === 'button' || nodeType === 'custombutton';
  }

  setFormData(reset?: boolean) {
    this.dataSetMap = this.appGlobalService.get('dataSetMap');
    try {
      if (this.formGroup) {
        this.resetFormData = reset ?? false;
        if (reset) {
          this.formGroup.reset({}, { emitEvent: false });
        }
        // Resolve page or pageName property
        if (this.formData?.page) {
          this.resolveNavigateToPageProperty('page');
        } else if (this.formData?.pageName) {
          this.resolveNavigateToPageProperty('pageName');
        }
        this.getImages();
        this.refreshBetaRadioOptions();
        this.formGroup.patchValue(this.formData);
        this.formGroup.markAsPristine();
        this.checkConditionOnValueChange();
      }
    } catch (e) {
      console.log(e);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);
    if (this.currentScreen) {
      this.allFields = null;
    }
  }

  onIconUpload(event: any, control: any, property?: any) {
    const file = event?.target?.files[0];
    if (!file) {
      return;
    }

    const reader: any = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e: any) => {
      $(`#${control}_img`).attr('src', e.target.result);
    };
    if (property?.title === 'PWA Icon') {
      return;
    }
    const curFile: any = file;
    curFile['fieldName'] = control;
    this.appGlobalService.write('fileUpload', curFile);
    const oldId = this.formGroup?.get(control)?.value?.icon?.[0]?.id;
    this.formGroup?.get(control)?.markAsDirty();
    this.formGroup?.patchValue({
      [control]: {
        type: 'uploaded',
        icon: [
          {
            id: oldId ? oldId : uuidv4(),
            fileName: curFile.name
          }
        ]
      }
    });
    this.imagePresent = true;
    // Reset file input value to allow re-uploading the same file
    event.target.value = '';
  }

  clearPwaValue(prop) {
    this.formGroup?.markAsDirty();
    this.formGroup?.controls[prop.name].setValue(null);
    $('#pwaIcon_img').removeAttr('src');
    if (this.pwaElement) {
      this.pwaElement.nativeElement.src = '';
    }
    this.pwaImagePresent = false;
  }

  onPWAIconUpload(event: any, control: any, property?: any) {
    const file = event?.target?.files[0];
    if (!file) {
      return;
    }

    const allowedTypes = ['image/png', 'image/svg+xml'];
    if (!allowedTypes.includes(file.type)) {
      this.showMessage('error', this.translate.instant('SVG_PNG_FILES'));
      return;
    }

    const curFile: any = file;
    curFile['fieldName'] = control;

    this.loader.show();

    if (file.type === 'image/png') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        $(`#${control}_img`).attr('src', e.target.result);

        image.onload = () => {
          // Validate if image is square (1:1 aspect ratio)
          if (image.width !== image.height) {
            this.showMessage('error', this.translate.instant('INVALID_ASPECT_RATIO'));
            this.loader.hide();
            return;
          }

          // Crop to multiple sizes
          const sizes = [72, 96, 128, 144, 152, 192, 384, 512];
          const croppedImages: File[] = [];

          sizes.forEach((size, index) => {
            this.cropImage(image, size, size, file.name, (croppedFile: File) => {
              croppedImages.push(croppedFile);
              if (croppedImages.length === sizes.length) {
                // Upload all cropped PNG images
                this.uploadCroppedImages(croppedImages, control);
              }
            });
          });
        };
      };
      reader.readAsDataURL(file);
    } else if (file.type === 'image/svg+xml') {
      // Directly upload the SVG file
      const reader: any = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {
        $(`#${control}_img`).attr('src', e.target.result);
      };
      const oldId = this.formGroup?.get(control)?.value?.icon?.[0]?.id;
      this.appGlobalService.write('fileUpload', curFile);
      this.formGroup?.get(control)?.markAsDirty();
      this.formGroup?.patchValue({
        [control]: {
          type: 'uploaded',
          icon: [
            {
              id: oldId ? oldId : uuidv4(),
              fileName: curFile.name
            }
          ]
        }
      });
      this.pwaImagePresent = true;
    }
    // Reset file input value to allow re-uploading the same file
    event.target.value = '';
  }

  cropImage(
    image: HTMLImageElement,
    width: number,
    height: number,
    fileName: string,
    callback: (croppedFile: File) => void
  ) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;

    context?.drawImage(image, 0, 0, width, height);
    const imageName = fileName.replace(/\.[^/.]+$/, '');
    canvas.toBlob((blob) => {
      if (blob) {
        const croppedFile = new File([blob], `${imageName}_${width}x${height}.png`, { type: 'image/png' });
        callback(croppedFile);
      }
    }, 'image/png');
  }

  uploadCroppedImages(croppedImages: File[], control: string) {
    this.appGlobalService.write('fileUpload', croppedImages);
    const icons = croppedImages.map((file: any) => {
      return {
        id: uuidv4(),
        fileName: file.name
      };
    });
    this.formGroup?.get(control)?.markAsDirty();
    this.formGroup?.patchValue({
      [control]: {
        type: 'uploaded',
        icon: icons.flat() // Store all uploaded icons data
      }
    });
    this.pwaImagePresent = true;
  }

  listenLoaderChange() {
    const propLoadingSub = this.store.select(propLoading).subscribe((isLoadingProps: boolean) => {
      this.isLoadingProps = isLoadingProps;
    });
    this.addToSubscriptionsList(propLoadingSub);
  }

  orderPages(filtered) {
    const pgs = filtered.sort((a, b) =>
      b?.pageTableType?.toLowerCase()?.localeCompare(a?.pageTableType?.toLowerCase())
    );
    const firOcc = pgs.find(
      (p) =>
        p?.pageTableType === pageTableType.QUERY_VIEW &&
        pgs.filter((pp) => pp?.pageTableType !== pageTableType.QUERY_VIEW).length
    );
    return pgs.map((pg) => {
      return pg.sid === firOcc?.sid ? { ...firOcc, ...{ separator: true } } : pg;
    });
  }

  /**
   * recursive method to find the list of transaction and transaction+analytical tables(inside/outside groups and nested groups also) except foe current table
   * @param tables // node children
   * @param sid // current table sid
   * @param picklist // result array which contains the tables
   */
  formPickuplistforTable(tables, sid, pickList) {
    if (!tables) {
      return [];
    }
    tables.forEach((node) => {
      if (!node.title) {
        return;
      }
      if (
        node.type === nodeType.TABLE &&
        node.data.sid !== sid &&
        (node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY)
      ) {
        pickList.push({ name: node?.data?.name, sid: node?.data?.sid });
      } else if (node.type === nodeType.GROUP) {
        if (node.children) {
          this.formPickuplistforTable(node.children, sid, pickList);
        }
      }
    });
    return pickList;
  }

  search(event, property) {
    const lookupTo = property.lookupTo;
    const propertyName = property.name;
    if (lookupTo.toLowerCase() === 'list of tables') {
      let filtered: any[] = [];
      const query = event.query;
      if (!this.tableNames) {
        this.results = [];
        return;
      }
      for (const tableName of this.tableNames) {
        if (tableName?.name.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
          filtered.push(tableName);
        }
      }
      if (propertyName === 't_pTable') {
        const tblName = this.formData?.name;
        if (tblName) {
          filtered = filter(filtered, (o) => o.name !== tblName);
        }
      } else if (propertyName === 'f_lookupTo') {
        this.store.dispatch(propertyActions.clearLookUp({ clear: false }));
        this.filteredLookup = [];
        this.filterLookUp(this.dataModelOrders, filtered);
        filtered = [
          ...this.filteredLookup.map((fld) => {
            return {
              name: fld.title,
              sid: fld.data.sid
            };
          })
        ];
      }
      this.results = filtered.filter((fld) => fld.name.toLowerCase().indexOf(query.toLowerCase()) >= 0);
    } else if (lookupTo.toLowerCase() === 'listofavailablepages') {
      const query = event.query;
      const screensToOmit = ['App Navigation', 'LandingPage'];
      const NOT_FOUND = -1;

      // For app navigation interim, only show list pages in the dropdown
      if (this.isFromModernize && this.currentScreen?.pageType === 'appNavigation') {
        const filtered: any[] = [];
        if (this.allScreens) {
          for (const screen of this.allScreens) {
            const screenName = screen?.pageName || '';
            if (
              screen?.pageType === 'list' &&
              screenName.toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
              screensToOmit.indexOf(screenName) === NOT_FOUND
            ) {
              filtered.push({
                name: screenName,
                sid: screen.sid,
                pageTableType: screen?.pageTableType ? screen.pageTableType : pageTableType.TRANSACTIONAL
              });
            }
          }
        }
        this.results = this.orderPages(filtered);
        return;
      }

      // For Member and Suite apps, use msScreenData from store
      if (
        this.isMicroserviceSuite &&
        this.memberScreensData &&
        typeof this.memberScreensData === 'object' &&
        !this.isCustomActionButton()
      ) {
        console.log('Processing msScreenData for nested dropdown:', this.memberScreensData);
        const groupedResults: any[] = [];
        const metaInfos = this.appGlobalService.get('refAppMetaInfos') || {};
        console.log('Available metaInfos:', metaInfos);

        // Process each app's screens from msScreenData (object with appId as keys)
        Object.keys(this.memberScreensData).forEach((appId: string) => {
          const screens = this.memberScreensData[appId];

          if (Array.isArray(screens)) {
            const appScreens: any[] = [];

            // Filter screens based on query
            screens.forEach((screen: any) => {
              const screenName = screen?.pageName || '';
              // Filter by query and omit specific screens
              if (
                screenName.toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
                screensToOmit.indexOf(screenName) === NOT_FOUND
              ) {
                appScreens.push({
                  name: screenName,
                  sid: screen.sid,
                  appId: appId,
                  pageTableType: screen?.pageTableType ? screen.pageTableType : pageTableType.TRANSACTIONAL
                });
              }
            });

            // Only add apps that have matching screens
            if (appScreens.length > 0) {
              // Get app name from metaInfo using appId (now object format)
              let appLabel = metaInfos[appId] || `App ${appId}`;
              if (this.appGlobalService.get('appId') === appId) {
                appLabel = this.appGlobalService.get('appName');
              }
              console.log(`Creating group for appId: ${appId}, label: ${appLabel}, screens: ${appScreens.length}`);

              groupedResults.push({
                label: appLabel,
                value: appId,
                items: this.orderPages(appScreens)
              });
            }
          }
        });

        console.log('Final grouped results:', groupedResults);
        this.results = groupedResults;
      } else {
        // For Independent apps or buttons in microservice suites, use allScreens (flat dropdown)
        if (!this.allScreens) {
          this.results = [];
          return;
        }
        const screensForNavigation = [...this.allScreens];
        const filtered: any[] = [];

        for (const screen of screensForNavigation) {
          const screenName = screen?.pageName || '';
          if (
            screenName.toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
            screensToOmit.indexOf(screenName) === NOT_FOUND
          ) {
            filtered.push({
              name: screenName,
              sid: screen.sid,
              pageTableType: screen?.pageTableType ? screen.pageTableType : pageTableType.TRANSACTIONAL
            });
          }
        }

        this.results = this.orderPages(filtered);
      }
    } else if (lookupTo.toLowerCase() === 'listofsametabledetailpages') {
      const filtered: any[] = [];
      const query = event.query;
      if (!this.allScreens) {
        this.results = [];
        return;
      }
      const screensToSearch = this.allScreens.filter((as: any) => {
        return as?.pageType === 'detail';
      });
      for (const screen of screensToSearch) {
        const screenName = screen?.pageName || '';
        if (screenName.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
          filtered.push({
            name: screenName,
            sid: screen.sid,
            pageTableType: screen?.pageTableType ? screen.pageTableType : pageTableType.TRANSACTIONAL
          });
        }
      }
      this.results = this.orderPages(filtered);
    } else if (lookupTo.toLowerCase().replace(/ /g, '') === 'listofwebservices') {
      if (this.currentPage?.currentPage === 'screens') {
        this.getServicesByTableId(event.query);
      } else {
        this.apiDatastart = 0;
        if (event.query || event.filter) {
          this.debounceFilter(event.query || event.filter);
        } else {
          this.getAllServices();
        }
      }
    } else if (lookupTo.toLowerCase().replace(/ /g, '') === 'listoffields') {
      const query = event.query;
      let indexedFields: any = [];
      let searchableFields: any = [];
      const filtered: any[] = [];
      if (!this.allFields) {
        this.store.dispatch(setFieldsInfoForTable({ fieldsInfo: null }));
        const getFIApiConstants = { ...ApiConstants.getFieldForPages };
        const tableId = this.currentScreen.tableId;
        const screenId = this.currentScreen.sid;
        getFIApiConstants.url = `${getFIApiConstants.url}${tableId}/${screenId}/${this.appGlobalService.get('appId')}`;
        this.store.dispatch(
          getFieldsInfoForTable({
            getFIApiConstants
          })
        );
      }
      const selectedScreenSub = this.store.select(fiForSelectedScreen).subscribe((fi: any) => {
        if (fi) {
          if (this.currentScreen?.sid) {
            // Perform parallel calls to fetch index and searchable fields
            const indexAndSearchInfo$ = forkJoin({
              indexData:
                this.bs.get(ApiConstants.getIndex, {
                  appId: this.appId,
                  orgId: this.orgId,
                  tableId: this.currentScreen.tableId
                }) || [],
              tableInfo: this.bs.get(ApiConstants.getSearchableFieldsByTableId, {
                tableId: this.currentScreen.tableId
              })
            });

            indexAndSearchInfo$.subscribe({
              next: ({ indexData, tableInfo }) => {
                this.tableInfo = tableInfo as {
                  currentTableForeignKeys?: any[];
                  currentTableIndexList?: any[];
                  currentTableSearchableField?: {
                    fields: any[];
                    foreignKeyFields?: any[];
                  };
                  foreignTableFields?: any[];
                };
                // Process indexed fields
                if (Array.isArray(indexData)) {
                  indexedFields = indexData.flatMap((item: any) => {
                    if (item && Array.isArray(item.fields)) {
                      return item.fields;
                    }
                    return [];
                  });
                }
                const currentTableRefferedFields = this.util.getSearchableReferredTableFields(
                  tableInfo,
                  this.currentScreen.tableId
                );
                searchableFields = Object.values(this.tableInfo?.currentTableSearchableField?.fields || {});
                this.processFields(
                  propertyName,
                  fi,
                  searchableFields,
                  indexedFields,
                  query,
                  currentTableRefferedFields
                );
              }
            });
            this.addToSubscriptionsList(indexAndSearchInfo$);
          } else {
            this.processFields(propertyName, fi, searchableFields, indexedFields, query);
          }
        }
      });
      this.addToSubscriptionsList(selectedScreenSub);
    } else if (lookupTo.toLowerCase().replace(/ /g, '') === 'listofsearchfields') {
      const query = event.query;
      let filtered: any[] = [];
      if (!this.searchFields) {
        const tableId = this.appGlobalService.get('lookupToTableId');
      }
      // let fieldsSub = this.store.select(lookupFields).pipe(distinctUntilChanged()).subscribe((res: any) => {
      const fieldsSub = this.baseService['get'](ApiConstants.getSearchableIndexFields, {
        tableId: this.currentScreen.tableId
      }).subscribe((searchableFieldsData: any) => {
        // console.log('searchFields', res);
        const searchableFields = Array.isArray(searchableFieldsData) ? searchableFieldsData : [];
        if (searchableFields || this.lookupTblProps) {
          let response;

          if (searchableFields) {
            response = searchableFields;
          } else {
            response = this.lookupTblProps.t_lookupFields ? this.lookupTblProps.t_lookupFields.split(',') : [];
          }

          const refAppMetaInfos = this.appGlobalService.get('refAppMetaInfos') || {};
          response.map((f: any) => {
            if (!this.fieldIdMap[f] && filtered.filter((fl) => fl.sid === f).length === 0) {
              filtered.push({
                name: refAppMetaInfos[f],
                sid: f
              });
            } else {
              filtered.push({ name: this.fieldIdMap[f], sid: f });
            }
          });
          this.searchFields = [...filtered];
          if (query) {
            filtered = filtered.filter((f: any) => {
              return f.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
            });
          }
          if (this.appId !== this.lookupTblProps?.appId) {
            // form map for display field otions
            const lkfieldsSub = this.store
              .select(tabMapFlds)
              .pipe(distinctUntilChanged())
              .subscribe((res: any) => {
                filtered = filtered.map((f) => {
                  const fld = res.find((fd) => fd.sid === f.sid);
                  return {
                    ...f,
                    tableId: fld.f_tableId,
                    appId: fld.appId,
                    f_type: fld.f_type
                  };
                });
              });
            this.addToSubscriptionsList(lkfieldsSub);
          }
          this.results = filtered;
        } else {
          this.results = [];
        }
      });
      this.addToSubscriptionsList(fieldsSub);
    } else if (lookupTo.toLowerCase().replace(/ /g, '') === 'listofdatasets') {
      const query = event.query;
      let filtered: any[] = [];
      if (this.datasets.length) {
        filtered = this.datasets.map((data) => {
          return { name: data.name, sid: data.sid };
        });
        this.searchFields = [...filtered];
        if (query) {
          filtered = filtered.filter((f: any) => {
            return f.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          });
        }
      }
      this.results = filtered;
    } else if (lookupTo.toLowerCase().replace(/ /g, '') === 'listoftranstables') {
      const query = event.query;
      let filtered: any[] = [];
      // Use tableNames from store instead of dataModelOrders to ensure newly added tables are reflected
      const tables = this.tableNames?.filter((t: any) => t.sid !== this.formData.sid) || [];
      filtered = [...tables];
      this.searchFields = [...filtered];
      if (query) {
        filtered = filtered.filter((f: any) => {
          return f.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
        });
      }
      this.results = filtered;
    } else if (lookupTo.toLowerCase() === 'listoftransdetailpages') {
      const filtered: any[] = [];
      const query = event.query;
      if (!this.allScreens) {
        this.results = [];
        return;
      }
      const screensToSearch = this.allScreens.filter((as: any) => {
        return as?.pageType === 'detail' && as?.pageTableType === pageTableType.TRANSACTIONAL;
      });
      for (let i = 0; i < screensToSearch.length; i++) {
        const screenName = screensToSearch[i]?.pageName || '';
        if (screenName.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
          filtered.push({
            name: screenName,
            sid: screensToSearch[i].sid,
            tableId: screensToSearch[i].tableId,
            appId: screensToSearch[i].appId
          });
        }
      }
      this.results = filtered;
    } else if (!lookupTo) {
      if (property.possibleValues) {
        this.results = property.possibleValues;
      }
    }
  }

  processFields(propertyName, fi, searchableFields, indexedFields, query, currentTableRefferedFields?: any) {
    const fields = this.processOption(propertyName, fi.fields); // Processing options for the fields
    this.searchableFields = [...searchableFields];
    const nodeChildernSub = this.nodeChildren$.subscribe((data: any) => {
      if (data) {
        const filteredGroup: any[] = [];
        let filtered: any[] = [];
        fields?.forEach((f: any) => {
          // Check if the field id is in tbldata
          const isSearchable = !!Object.values(searchableFields).some((field: any) => field.sid === f.sid);
          if (
            data.find((d) => d.id === f.sid && !f.f_transientField) &&
            f.name.toLowerCase().includes(query.toLowerCase())
          ) {
            // Add the 'searchable' property based on the presence of the fieldId in tbldata
            filtered.push({
              name: f.name,
              sid: f.sid,
              type: 'datamodelField',
              searchable: isSearchable,
              indexed: indexedFields.includes(f.sid)
            });
          }
        });

        if (filtered?.length) {
          filteredGroup.push({
            name: this.translate.instant('TABLE_FIELDS'),
            items: filtered
          });
        }

        // When it is an Elasticsearch database and referred table fields are added to the table,
        if (this.techStackData?.textSearch === GlobalConstants.searchDbEs && Array.isArray(data)) {
          currentTableRefferedFields?.groupedFields?.forEach((gf) => {
            if (gf.items?.length) {
              const items = gf.items
                .filter(
                  (f) =>
                    !f.f_transientField &&
                    data?.find((df) => df.id == f.sid) &&
                    f.name.toLowerCase().includes(query.toLowerCase())
                )
                ?.map((f: any) => {
                  return {
                    name: f.name,
                    sid: f.sid,
                    type: 'datamodelField',
                    searchable: true,
                    indexed: indexedFields.includes(f.id),
                    fkId: f.fkId,
                    fkTableSid: f.fkTableSid,
                    fkAppId: f.fkAppId
                  };
                });
              if (items?.length) {
                filtered = [...filtered, ...items];
                filteredGroup.push({
                  name: gf.label,
                  items: items
                });
              }
            }
          });
        }

        this.allFields = [...filtered];

        this.results = filteredGroup; // Assigning the filtered results
      }
    });
    this.addToSubscriptionsList(nodeChildernSub); // Managing subscription
  }

  filterLookUp(tableOrders, filtered) {
    tableOrders.forEach((node) => {
      if (!node.title) {
        return;
      }
      if (
        node.type === nodeType.TABLE &&
        (node.data.t_type === DMConstants.TRANS_ONLY || node.data.t_type === DMConstants.TRANS_ANALY)
      ) {
        this.filteredLookup.push(node);
      } else if (node.type === nodeType.GROUP) {
        if (node.children) {
          this.filterLookUp(node.children, filtered);
        }
      }
    });
  }
  searchdrp(event, property) {
    this.drpSearchTxt = event.filter;
  }

  attachInfiniteScroll(ctrl) {
    if (ctrl === 'service' && this.currentPage?.currentPage === 'screens') {
      const tracker = document.getElementsByClassName('p-autocomplete-overlay')[0] as HTMLInputElement;
      const windowYOffsetObservable = fromEvent(tracker, 'scroll').pipe(
        map(() => {
          return tracker.scrollTop;
        })
      );

      const scrollSubscription = windowYOffsetObservable.subscribe((scrollPos: number) => {
        console.log(tracker.offsetHeight + scrollPos);
        console.log(tracker.scrollHeight);
        if (tracker.offsetHeight + scrollPos + 0.7 >= tracker.scrollHeight) {
          this.apiDatastart += 1;
          if (this.totalRecords > this.servivcesList.length) {
            setTimeout(() => {
              this.getAllServices();
            }, 100);
          }
        }
      });
      this.subscriptions.push(scrollSubscription);
    }
  }

  getAllScreens() {
    const screenSelector = this.isFromModernize ? allInterimScreens : allScreens;
    const allScreensSub = this.store.select(screenSelector).subscribe((scs: any) => {
      if (scs?.length) {
        this.allScreens = scs;
      }
    });
    this.addToSubscriptionsList(allScreensSub);
  }

  debounceFilter = debounce(this.getAllServices.bind(this), 2000);

  getAllServices(srctext?: string) {
    const apiConstants = { ...ApiConstants.getServicesFrmDataTbl };
    const filterValue = {
      pgNo: this.apiDatastart,
      length: 50,
      searchText: srctext ? srctext : ''
    };
    let queryParams = new HttpParams();
    queryParams = queryParams.append('searchText', filterValue.searchText);
    queryParams = queryParams.append('pgNo', filterValue.pgNo);
    queryParams = queryParams.append('length', filterValue.length);
    const url = `${apiConstants.url}/${this.appId}?${queryParams}`;
    const apiObj = { ...apiConstants, ...{ url: url } };
    const serviceSub = this.baseService.get(apiObj).subscribe(
      (allTables: any) => {
        const data = cloneDeep(allTables);
        if (data && data.results) {
          if (this.apiDatastart) {
            this.servivcesList = sortBy([...this.servivcesList, ...data.results], ['tableName']);
          } else {
            this.servivcesList = sortBy(data.results, ['tableName']);
          }
          this.totalRecords = data.total;
          if (this.currentPage?.currentPage === 'screens') {
            if (!this.servivcesList) {
              this.results = [];
              return;
            }
            const tblserList = this.servivcesList.filter((s) => s.tableId === this.currentScreen.tableId);
            const cusserList = this.servivcesList.filter(
              (s) => !s.tableName || s.serviceType === 'INTEGRATION_SERVICE'
            );
            const servs = [...tblserList, ...cusserList];
            const filtered: any[] = [];
            const currentTblGroup: any = {};
            for (const serv of servs) {
              const serviceName = serv?.serviceName || '';
              let curOptions: any = null;

              if (!serv.tableName && serv.serviceType === 'INTEGRATION_SERVICE') {
                const path = serv.url.split('/');
                const tblName = path[path.length - 1];
                serv.tableName = tblName;
              } else if (!serv.tableName) {
                serv.tableName = 'Custom';
              }
              curOptions = {
                name: serviceName,
                sid: serv.sid,
                tableName: serv.tableName,
                tableId: serv.tableId,
                apiGroupId: serv.apiGroupId
              };

              if (!Object.prototype.hasOwnProperty.call(currentTblGroup, serv?.tableName)) {
                currentTblGroup[serv?.tableName] = [];
              }
              currentTblGroup[serv?.tableName].push(curOptions);
            }
            for (const key in currentTblGroup) {
              filtered.push({ label: key, value: key, items: currentTblGroup[key] });
            }
            this.results = filtered;
          }
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
    this.addToSubscriptionsList(serviceSub);
  }

  getServicesByTableId(srctext) {
    const apiConstants = { ...ApiConstants.getServicesByTblId };
    const url = `${apiConstants.url}/${this.appId}/${this.currentScreen.tableId}`;
    const apiObj = { ...apiConstants, ...{ url: url } };
    const serviceSub = this.baseService.get(apiObj).subscribe(
      (allTables: any) => {
        if (allTables) {
          this.servivcesList = cloneDeep(allTables);
          if (this.currentPage?.currentPage === 'screens') {
            if (!this.servivcesList) {
              this.results = [];
              return;
            }
            const tblserList = this.servivcesList.filter(
              (s) =>
                s.tableId === this.currentScreen.tableId && (!srctext || (srctext && s.serviceName.includes(srctext)))
            );
            const cusserList = this.servivcesList.filter((s) => !s.tableName);
            const servs = [...tblserList, ...cusserList];
            const filtered: any[] = [];
            const currentTblGroup: any = {};
            for (const serv of servs) {
              const serviceName = serv?.serviceName || '';
              let curOptions: any = null;
              if (!serv.tableName) {
                serv.tableName = 'Custom';
              }
              curOptions = {
                name: serviceName,
                sid: serv.sid,
                tableName: serv.tableName,
                tableId: serv.tableId
              };
              if (!Object.prototype.hasOwnProperty.call(currentTblGroup, serv?.tableName)) {
                currentTblGroup[serv?.tableName] = [];
              }
              currentTblGroup[serv?.tableName].push(curOptions);
            }
            for (const key in currentTblGroup) {
              filtered.push({ label: key, value: key, items: currentTblGroup[key] });
            }
            this.results = filtered;
          }
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
    this.addToSubscriptionsList(serviceSub);
  }

  clearDisplayFieldSearch() {
    this.searchFields = null;
    this.store.dispatch(propertyActions.setSearchableFields({ searchFields: null }));
  }
  getTechstackData(id, apiName) {
    const promise = new Promise<void>((resolve, reject) => {
      // this.bs.ge
      this.ref$ = this.bs.get(ApiConstants[apiName], { appId: id }).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (err: any) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        }
      });
      this.addToSubscriptionsList(this.ref$);
    });
    return promise;
  }

  getTableProps(selectedValue) {
    this.configurePickupListIfNeeded(selectedValue);
    this.fetchAndProcessTechStack(selectedValue);
    this.updateAnalyticalTableName(selectedValue);
  }

  private configurePickupListIfNeeded(selectedValue): void {
    const sid = this.formData?.sid;
    const currentType = this.formData?.t_type;
    const isTransitioning = currentType !== DMConstants.TRANS_ANALY || currentType !== DMConstants.TRANS_ONLY;
    const isTransactionalType = selectedValue === DMConstants.TRANS_ANALY || selectedValue === DMConstants.TRANS_ONLY;
    if (isTransitioning && isTransactionalType && sid) {
      this.pickupListService.configurePickupList(sid);
    }
  }

  private fetchAndProcessTechStack(selectedValue): void {
    const currentType = this.formData?.t_type;
    const needsTechStack =
      (currentType !== DMConstants.ANALY_ONLY || currentType !== DMConstants.TRANS_ONLY) &&
      (selectedValue === DMConstants.TRANS_ANALY || selectedValue === DMConstants.ANALY_ONLY);

    if (!needsTechStack) {
      this.currentpropertiesValues = { ...this.currentpropertiesValues, ...{ t_type: selectedValue } };
      return;
    }

    this.appGlobalService.write('ValidateMultipleVal', true);
    const isNonIndependentApp = this.applicationType !== ApplicationTypes.INDEPENDENT;
    const techStackApiConfig = isNonIndependentApp
      ? ApiConstants.getTechnologyStackBySuiteId
      : ApiConstants.getTechnologyStackByAppId;
    const techStackParams = isNonIndependentApp
      ? { suiteid: this.suiteId, shareddbid: this.appGlobalService.get('sharedDbId') }
      : { appId: this.appId };

    const techSub = this.baseService.get(techStackApiConfig, techStackParams).subscribe((techStackData: any) => {
      this.processTechStackData(techStackData, selectedValue);
    });
    this.addToSubscriptionsList(techSub);
  }

  private processTechStackData(techStackData: any, selectedValue): void {
    this.appGlobalService.write('ValidateMultipleVal', false);
    if (!techStackData) {
      return;
    }

    this.handleBigQueryDatasets(techStackData);

    if (this.validateTechStackConfig(techStackData)) {
      this.formGroup?.get('t_type')?.patchValue(this.currentpropertiesValues.t_type);
      return;
    }

    this.currentpropertiesValues = { ...this.currentpropertiesValues, ...{ t_type: selectedValue } };
    this.formGroup?.get('t_type')?.patchValue(selectedValue);
    this.formGroup?.markAsDirty();
  }

  private handleBigQueryDatasets(techStackData: any): void {
    this.additionalCondCheck.t_datasetName = false;
    this.dataSetJson = [...(techStackData?.datasets ?? {})];
    this.datasets = [...this.dataSetJson];
    const datasetName = this.resolveDatasetName(techStackData);
    if (datasetName) {
      this.formGroup?.get('t_datasetName')?.patchValue(datasetName);
      this.formGroup?.markAsDirty();
    }
  }

  private resolveDatasetName(techStackData: any): any {
    const datasetName = this.formGroup?.get('t_datasetName')?.value;
    if (datasetName && typeof datasetName === 'string' && this.datasets.length) {
      const setNme = this.datasets.find((dt) => dt.sid === datasetName);
      if (setNme) {
        return { name: setNme.name, sid: setNme.sid };
      }
      return null;
    }
    if (datasetName && typeof datasetName === 'string' && !this.datasets.length) {
      return null;
    }
    if (techStackData.defaultDataset && !datasetName) {
      const defaultNme = this.dataSetJson.find((dt) => dt.sid === techStackData.defaultDataset);
      if (defaultNme) {
        return { name: defaultNme.name, sid: defaultNme.sid };
      }
      return null;
    }
    return datasetName;
  }

  private validateTechStackConfig(techStackData: any): boolean {
    this.isLoadingProps = false;
    if (!techStackData.analyticalDb) {
      this.zone.run(() => this.showMessage('error', this.translate.instant('SELECT_ANALYTICAL_DB')));
      return true;
    }
    if (!techStackData.datasets || techStackData.datasets.length === 0) {
      this.zone.run(() => this.showMessage('error', this.translate.instant('DATASETS_ERR')));
      return true;
    }
    return false;
  }

  private updateAnalyticalTableName(selectedValue): void {
    const name = selectedValue === DMConstants.TRANS_ANALY ? this.currentpropertiesValues?.name : null;
    this.formGroup?.get('t_aTableName')?.patchValue(name);
  }
  setTableTypeListener() {
    if (!this.formGroup) {
      return;
    }
    if (typeof this.formFieldSub === 'function') {
      return;
    }
    this.formFieldSub = this.formGroup
      .get('t_type')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((selectedValue) => {
        if (!this.formGroup?.get('t_type')?.pristine) {
          if (selectedValue) {
            this.getTableProps(selectedValue);
          }
        }
      });
    this.addToSubscriptionsList(this.formFieldSub);
  }
  setMultipleValListener() {
    if (!this.formGroup) {
      return;
    }
    if (typeof this.formFieldSub === 'function') {
      return;
    }
    this.formFieldSub = this.formGroup
      .get('f_hasMultiVal')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((selectedValue) => {
        if (selectedValue) {
          if (!this.formGroup?.get('f_hasMultiVal')?.pristine) {
            const sid = this.formData?.f_tableId;
            if (this.formGroup?.get('f_lookUpOMap')) {
              this.formGroup?.get('f_lookUpOMap')?.patchValue(null);
              this.additionalCondCheck.f_lookUpOMap = true;
            }
            if (this.formGroup?.get('f_dVal')) {
              this.formGroup?.get('f_dVal')?.patchValue(null);
            } else {
              this.formGroup?.get('f_hasMultiVal')?.patchValue(true);
            }
            if (
              this.formData.f_type.toLowerCase() === 'dropdown' ||
              this.formData.f_type.toLowerCase() === 'checkboxgroup'
            ) {
              this.additionalCondCheck.f_dVal = false;
            } else {
              this.additionalCondCheck.f_dVal = true;
            }
            this.formGroup?.markAsDirty();
          }
        } else {
          this.additionalCondCheck.f_dVal = false;
          if (this.formData.f_type.toLowerCase() === 'lookup') {
            if (this.lookupTblProps) {
              this.store.dispatch(
                propertyActions.setLookupFields({
                  lookupFields: this.lookupTblProps?.lookupFields
                })
              );
            }
          }
          this.additionalCondCheck.f_lookUpOMap = false;
        }
      });
    this.addToSubscriptionsList(this.formFieldSub);
  }
  setFormulaListener() {
    if (!this.formGroup) {
      return;
    }
    if (typeof this.formFieldSub === 'function') {
      return;
    }
    this.formFieldSub = this.formGroup
      .get('f_formula')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((selectedValue) => {
        if (!this.formGroup?.get('f_formula')?.pristine) {
          if (selectedValue) {
            this.formGroup?.get('f_editing')?.patchValue('no', { emitEvent: false });
            this.formGroup?.get('f_dVal')?.patchValue(null);
            this.formGroup?.controls.f_editing.disable();
            this.additionalCondCheck.f_dVal = true;
          } else {
            this.formGroup?.get('f_editing')?.patchValue('yes', { emitEvent: false });
            this.formGroup?.controls.f_editing.enable();
            this.additionalCondCheck.f_dVal = false;
          }
        }
      });
    this.addToSubscriptionsList(this.formFieldSub);
  }

  clearlookupTo() {
    if (
      this.formGroup?.get('f_lookUpIMap')?.value ||
      this.formGroup?.get('f_lookUpOMap')?.value ||
      this.formGroup?.get('f_dField')?.value
    ) {
      this.formGroup?.get('f_lookUpIMap')?.patchValue(null);
      this.formGroup?.get('f_lookUpOMap')?.patchValue(null);
      this.additionalCondCheck.f_lookUpIMap = true;
      this.additionalCondCheck.f_lookUpOMap = true;
      this.formGroup?.get('f_dField')?.patchValue(null);
      this.formGroup?.get('f_lookupTo')?.markAsPristine();
      this.clearDisplayFieldSearch();
    }
  }

  setLookupToListener() {
    if (!this.formGroup) {
      return;
    }
    if (typeof this.formFieldSub === 'function') {
      return;
    }
    this.formFieldSub = this.formGroup
      .get('f_lookupTo')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((selectedValue) => {
        if (selectedValue) {
          if (!this.formGroup?.get('f_lookupTo')?.pristine) {
            this.selectedLookUp = selectedValue;
            this.appGlobalService.write('selectedLookUp', selectedValue);
            this.appGlobalService.write('ValidateLookupTo', true);
            this.loader.show();
            const apiConstants = ApiConstants.getDatamodelTableData;
            let id;
            if (selectedValue.value) {
              id = selectedValue.value;
            } else {
              id = selectedValue;
            }
            if (id.sid) {
              id = id.sid;
            }
            const tblDataSub = this.baseService[apiConstants.method](apiConstants, { sid: id }).subscribe({
              next: (tblData: any) => {
                try {
                  if (tblData) {
                    this.fieldMap = {};
                    if (!this.fieldIdMap[tblData.t_lookupFields.split(',')[0]] && tblData.t_lookupFields) {
                      tblData.t_lookupFields.split(',').forEach((idt: any) => {
                        this.fieldMap[idt] = this.appGlobalService
                          .get('refAppMetaInfos')
                          .find((tbl) => tbl.modelId === idt)?.name;
                      });
                      this.fieldMap = { ...this.fieldMap, ...this.fieldIdMap };
                    } else {
                      this.fieldMap = { ...this.fieldIdMap };
                    }
                    this.appGlobalService.write('ValidateLookupTo', false);
                    if (!tblData.t_funcPKey && !tblData.t_lookupFields) {
                      this.loader.hide();
                      this.zone.run(() => {
                        this.showMessage(
                          'error',
                          'Lookup Fields & Functional primary key Properties are not configured for the selected table. Please check and add'
                        );
                      });
                      this.formGroup?.get('f_lookupTo')?.patchValue(null);
                      this.formGroup?.get('f_dField')?.patchValue(null);
                      this.appGlobalService.write('lookupToTableId', null);
                      this.store.dispatch(propertyActions.setLookupFields({ lookupFields: null }));
                      this.formGroup?.get('f_lookUpIMap')?.patchValue(null);
                      this.formGroup?.get('f_lookUpOMap')?.patchValue(null);
                      this.additionalCondCheck.f_lookUpIMap = true;
                      this.additionalCondCheck.f_lookUpOMap = true;
                      this.clearDisplayFieldSearch();
                      this.formGroup?.markAsDirty();
                      this.lookupTblProps = null;
                    } else {
                      // this.clearlookupTo();
                      this.store.dispatch(setSelectedLKTbl({ selLkTbl: null }));
                      this.store.dispatch(
                        setSelectedLKTbl({
                          selLkTbl: tblData
                        })
                      );
                      this.formGroup?.get('f_lookupTo')?.patchValue(selectedValue);
                      this.formGroup?.get('f_lookupTo')?.markAsPristine();
                      this.appGlobalService.write('lookupToTableId', selectedValue.sid);
                      this.formGroup?.get('f_dField')?.patchValue(null);
                      this.store.dispatch(propertyActions.setLookupFields({ lookupFields: null }));
                      this.store.dispatch(propertyActions.setMandatryFil({ mandatoryFilters: null }));
                      this.formGroup?.get('f_lookUpIMap')?.patchValue(null);
                      this.formGroup?.get('f_lookUpOMap')?.patchValue(null);
                      this.clearDisplayFieldSearch();
                      this.lookupTblProps = tblData;
                      const lookupFieldsData = tblData.t_lookupFields;
                      this.store.dispatch(
                        propertyActions.setLookupFields({
                          lookupFields: lookupFieldsData
                        })
                      );
                      this.additionalCondCheck.f_lookUpOMap = false;
                      const mandatoryFiltersValue = tblData.t_mFilters;
                      const optionalFilters = tblData.t_oFilters;
                      if (mandatoryFiltersValue || optionalFilters) {
                        this.store.dispatch(
                          propertyActions.setMandatryFil({
                            mandatoryFilters: {
                              mandatoryFilters: tblData.t_mFilters,
                              optionalFilters: tblData.t_oFilters
                            }
                          })
                        );
                        this.additionalCondCheck.f_lookUpIMap = false;
                      } else {
                        this.additionalCondCheck.f_lookUpIMap = true;
                      }
                      // get fields of lookupto
                      const fieldSub = this.baseService[apiConstants.method](ApiConstants.getFieldInfo, {
                        tableId: id
                      }).subscribe({
                        next: (data: any) => {
                          this.loader.hide();
                          try {
                            this.store.dispatch(propertyActions.settableFields({ tabMapFlds: null }));
                            const tabMapFields = data;
                            this.store.dispatch(
                              propertyActions.settableFields({
                                tabMapFlds: tabMapFields
                              })
                            );
                          } catch (e) {
                            console.error(e);
                          }
                        },
                        error: (error: any) => {
                          this.loader.hide();
                        }
                      });
                      this.addToSubscriptionsList(fieldSub);
                      this.formGroup?.markAsDirty();
                    }
                  }
                } catch (e) {
                  console.error(e);
                }
              },
              error: (error: any) => {
                this.loader.hide();
                this.formGroup?.get('f_lookupTo')?.reset();
                this.appGlobalService.write('ValidateLookupTo', false);
              }
            });
            this.addToSubscriptionsList(tblDataSub);
          } else if (this.selectedLookUp === '' || this.selectedLookUp.value === selectedValue) {
            const apiConstants = ApiConstants.getDatamodelTableData;
            let id;
            if (selectedValue.value) {
              id = selectedValue.value;
            } else {
              id = selectedValue;
            }
            if (id.sid) {
              id = id.sid;
            }
            const propertySub = this.baseService[apiConstants.method](apiConstants, { sid: id }).subscribe({
              next: (data: any) => {
                this.loader.hide();
                if (data) {
                  this.fieldMap = {};
                  if (!this.fieldIdMap[data.t_lookupFields.split(',')[0]]) {
                    data.t_lookupFields.split(',').forEach((idt: any) => {
                      this.fieldMap[
                        this.appGlobalService.get('refAppMetaInfos').filter((tbl) => tbl.modelId === idt)[0].modelId
                      ] = this.appGlobalService.get('refAppMetaInfos').filter((tbl) => tbl.modelId === idt)[0].name;
                    });
                    this.fieldMap = { ...this.fieldMap, ...this.fieldIdMap };
                  } else {
                    this.fieldMap = { ...this.fieldIdMap };
                  }
                }
              }
            });
            this.addToSubscriptionsList(propertySub);
          }
        } else {
          this.clearlookupTo();
        }
      });
    this.addToSubscriptionsList(this.formFieldSub);
  }

  setTransientFieldListener() {
    if (typeof this.transientFieldSub === 'function') {
      return;
    }
    this.transientFieldSub = this.formGroup
      ?.get('f_transientField')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((selectedValue) => {
        if (this.formData) {
          if (this.formData?.f_type === 'Auto-number') {
            // For auto number editing is not allowed
            this.formGroup?.controls.f_editing?.disable();
          } else if (
            !this.formData.f_sysF &&
            !this.formData.f_formula &&
            this.util.checkEditPermission(this.pageName)
          ) {
            this.formGroup?.controls.f_editing?.enable();
          }
        }
        // this.formGroup.get('dataPopulationStrategy').patchValue(null);
        /* } */
      });
    this.addToSubscriptionsList(this.transientFieldSub);
  }

  listenForPageChange() {
    const currPageSub = this.store.select(currentPage).subscribe((page: any) => {
      this.currentPage = page;
      if (this.currentPage?.currentPage === 'screens') {
        this.getAllScreens();
        // this.getAllServices();
      } else if (this.currentPage?.currentPage === 'datamodel') {
        this.setLookupToListener();
      }
    });
    this.addToSubscriptionsList(currPageSub);
  }

  populateOptionSuffix(field) {
    if (
      this.techStackData?.textSearch === GlobalConstants.searchDbEs &&
      !field?.searchable &&
      this.currentScreen?.pageTableType !== 'QUERY_VIEW'
    ) {
      return `( ${GlobalConstants.notSearchable} )`;
    } else if (
      this.techStackData?.textSearch === GlobalConstants.searchDbRdbms &&
      !field?.indexed &&
      this.currentScreen?.pageTableType !== 'QUERY_VIEW'
    ) {
      return `( ${GlobalConstants.notIndexed} )`;
    }

    return '';
  }
  handleAppConnectivityChanges() {
    this.subscriptions.push(
      this.appGlobalService.isOnline$.subscribe((isOnline) => {
        if (isOnline) {
          // handle online mode
          console.log('Online...');
          if (this.util.checkEditPermission(this.pageName)) {
            this.disallowEdit = false;
          }
        } else {
          // handle offline mode
          console.log('Offline...');
          this.disallowEdit = true;
        }
      })
    );
  }

  /**
   * Subscribe to merge status changes and disable editing when merge is in progress
   */
  private subscribeToMergeStatus(): void {
    const mergeStatusSub = this.mergeStatusService.mergeStatus$.subscribe((status) => {
      if (status.isMergeInProgress) {
        this.disallowEdit = true;
        this.formGroup?.disable({ onlySelf: true, emitEvent: false });
      } else if (this.util.checkEditPermission(this.pageName)) {
        // Only re-enable if user has edit permission
        this.zone.run(() => {
          this.disallowEdit = false;
          this.formGroup?.enable({ onlySelf: true, emitEvent: false });
          this.setFormData();
        });
      }
    });
    this.subscriptions.push(mergeStatusSub);
  }

  triggerLookUpListener(option: string) {
    // this.selectedGroup=option;
    // this.formGroup.get('f_lookupTo').markAsDirty();
    // this.formGroup.get('f_lookupTo').setValue(option['value']);
  }

  clearIconValue(prop) {
    this.clearValueConfirmation(prop, this.clearValue.bind(this));
  }

  clearPWAIconValue(prop) {
    this.clearValueConfirmation(prop, this.clearPwaValue.bind(this));
  }

  clearValueConfirmation(prop: any, callback: (prop: any) => void) {
    this.confirmationDialogService.confirm({
      message: this.translate.instant('REMOVE_CONFIRMATION_IMAGES_ICON', { title: prop.title }),
      header: 'Confirmation',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        callback(prop);
      }
    });
  }

  clearValue(prop) {
    this.formGroup?.markAsDirty();
    this.formGroup?.controls[prop.name].setValue(null);
    $('#urlIcon_img').removeAttr('src');
    if (this.imageElement) {
      this.imageElement.nativeElement.src = '';
    }
    this.imagePresent = false;
  }
  toggleGroup(group: any) {
    this.groupedLookUpTables.find((ci) => ci.label === group.label).expanded = !this.groupedLookUpTables.find(
      (ci) => ci.label === group.label
    ).expanded;
    event?.stopPropagation();
    this.groupedLookUpTables
      .find((ci) => ci.label === group.label)
      .items.forEach((fld) => {
        fld.expanded = !fld.expanded;
      });
    setTimeout(function () {
      $('p-dropdownitem').each(function () {
        if ($(this).find('.expanded').length > 0) {
          $(this).addClass('d-none');
        } else {
          $(this).removeClass('d-none');
        }
      });
    }, 100);
  }

  preventCollapse() {
    this.groupedLookUpTables.forEach((tbl) => {
      tbl.expanded = false;
      if (tbl.items) {
        tbl.items.forEach((i) => {
          i.expanded = false;
        });
      }
    });
    setTimeout(function () {
      $('p-dropdownitem').each(function () {
        if ($(this).find('.expanded').length > 0) {
          $(this).addClass('d-none');
        } else {
          $(this).removeClass('d-none');
        }
      });
    }, 100);
  }

  onCheckboxChange(event, property) {
    const uncheckCallback = () => {
      // intentionally left blank, to be used in confirmation dialog
    };
    if (property.name === 'sendMail') {
      if (event.checked === false) {
        this.confirmationDialogService.confirm({
          message: this.translate.instant('MAIL_UNCHECK_CONFIRMATION'),
          accept: uncheckCallback,
          reject: () => {
            if (this.formGroup && this.formGroup.controls[property.name]) {
              this.formGroup.controls[property.name].setValue(true);
              this.formData = { ...this.formData, ...{ [property.name]: true } };
              this.checkConditionOnValueChange();
            }
          }
        });
      }
    }
  }

  /**
   * Handles the conflict between Row Group and Infinite Scroll properties.
   * When Row Group is set to 'yes' and Infinite Scroll is enabled, shows a confirmation dialog.
   * @returns true if a conflict was detected and handled (to prevent further processing), false otherwise
   */
  handleRowGroupInfiniteScrollConflict(selectedValue: any, currFormData: any): boolean {
    const rowGroupControl = this.formGroup?.get('rowGroup');
    const infiniteScrollControl = this.formGroup?.get('infiniteScroll');
    const newRowGroup = selectedValue?.rowGroup;
    const newInfiniteScroll = selectedValue?.infiniteScroll;

    // Case 1: infiniteScroll was enabled while rowGroup is 'yes'
    if (infiniteScrollControl?.dirty && newInfiniteScroll === true && newRowGroup === 'yes') {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('INFINITE_SCROLL_ROW_GROUP_CONFLICT'),
        header: this.translate.instant('CONFIRMATION'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          // Disable Row Group when Infinite Scroll is enabled
          this.formGroup?.controls['rowGroup']?.setValue('no', { emitEvent: false });
          currFormData.rowGroup = 'no';
          this.formData = { ...currFormData };
          this.dispatchCall();
        },
        reject: () => {
          // Revert Infinite Scroll to unchecked
          this.formGroup?.controls['infiniteScroll']?.setValue(false, { emitEvent: false });
          currFormData.infiniteScroll = false;
          this.formData = { ...currFormData };
          this.checkConditionOnValueChange();
        }
      });
      return true;
    }

    // Case 2: rowGroup was changed to 'yes' while infiniteScroll is enabled
    if (rowGroupControl?.dirty && newRowGroup === 'yes' && newInfiniteScroll) {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('ROW_GROUP_INFINITE_SCROLL_CONFLICT'),
        header: this.translate.instant('CONFIRMATION'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          // Disable Infinite Scroll when Row Group is enabled
          this.formGroup?.controls['infiniteScroll']?.setValue(false, { emitEvent: false });
          currFormData.infiniteScroll = false;
          this.formData = { ...currFormData };
          this.dispatchCall();
        },
        reject: () => {
          // Revert Row Group to 'no'
          this.formGroup?.controls['rowGroup']?.setValue('no', { emitEvent: false });
          currFormData.rowGroup = 'no';
          this.formData = { ...currFormData };
          this.checkConditionOnValueChange();
        }
      });
      return true;
    }
    return false;
  }

  checkforQueryTblMandFilters(val?) {
    const querytblDataSub = this.store.select(queryTableData).subscribe((data: any) => {
      if (data) {
        try {
          if (this.currNodeType?.toLowerCase() === 'filterfield') {
            if (data?.t_mandatory_filters?.includes(val.currentNode)) {
              this.additionalCondCheck.mandatory = false;
              this.formGroup?.controls.mandatory?.disable();
            } else {
              this.additionalCondCheck.mandatory = true;
            }
          } else if (this.currNodeType?.toLowerCase() === 'grid') {
            if (data?.t_mandatory_filters?.length) {
              this.conditionCheckGp['Parameter Mapping'] = true;
            } else {
              this.conditionCheckGp['Parameter Mapping'] = false;
            }
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        this.additionalCondCheck.mandatory = true;
      }
    });
    this.addToSubscriptionsList(querytblDataSub);
  }

  toggleCustomRender(valuechange, selectedValue, currFormData) {
    if (valuechange && Object.prototype.hasOwnProperty.call(this.formGroup?.controls, 'formatDisplay')) {
      if (selectedValue?.formatDisplay !== null && !this.formGroup?.get('formatDisplay')?.pristine) {
        if (selectedValue?.formatDisplay) {
          this.disableOrEnableForToggle('displayAsToggleSwitch', false, currFormData, false, true);
        } else {
          this.disableOrEnableForToggle('displayAsToggleSwitch', true, currFormData, false, false);
        }
      }
      if (selectedValue?.displayAsToggleSwitch !== null && !this.formGroup?.get('displayAsToggleSwitch')?.pristine) {
        if (selectedValue?.displayAsToggleSwitch) {
          this.disableOrEnableForToggle('formatDisplay', false, currFormData, true, false);
        } else {
          this.disableOrEnableForToggle('formatDisplay', true, currFormData, false, false);
        }
      }
    }
  }

  disableOrEnableForToggle(formValue, canEnable, currFormData, displayAsToggleSwitchValue, formatDisplayValue) {
    if (canEnable) {
      this.formGroup?.controls[formValue].enable({ onlySelf: true });
    } else {
      this.formGroup?.controls[formValue].disable({ onlySelf: true });
    }
    this.formGroup?.markAsPristine();
    currFormData.displayAsToggleSwitch = displayAsToggleSwitchValue;
    currFormData.formatDisplay = formatDisplayValue;
  }

  updateActiveFiltersVisibility() {
    if (this.currNodeType == 'pageView' && this.currentScreen?.pageTableType != pageTableType.QUERY_VIEW) {
      if (this.settingsData?.deactivateRecords && this.currentScreen?.pageType == 'list') {
        this.conditionCheckGp['Active/Inactive Filter'] = true;
        this.additionalCondCheck.displayFilterIn = false;
      } else {
        this.conditionCheckGp['Active/Inactive Filter'] = false;
        this.additionalCondCheck.displayFilterIn = true;
      }
    } else {
      this.conditionCheckGp['Active/Inactive Filter'] = false;
      this.additionalCondCheck.displayFilterIn = true;
    }
  }

  checkForeignKeyUsed(treeKey: string, foreignKeyids: any[]): boolean {
    const node = $.ui.fancytree.getTree('#screensTree').getNodeByKey(treeKey);
    if (node && node.children) {
      return node.children.some((child) =>
        foreignKeyids.includes(child.data?.properties?.lookupConfiguration?.lookupToForeignkey)
      );
    }
    return false;
  }
  parentTblErrorMsg = '';
  parentTblErrorMsgPopupVisible = false;
  ngOnInit(): void {
    this.applicationType = this.appGlobalService.get('applicationType');
    this.updateFilteredEnvironmentsForDialog();
    const selectedAppSub = this.store.select(selectedAppData).subscribe((app: any) => {
      if (app) {
        this.applicationType = app.applicationType;
        this.isMicroserviceSuite = this.applicationType !== ApplicationTypes.INDEPENDENT;
        if (!this.isMicroserviceSuite) {
          this.setConsumerApps([app]);
        }
        this.updateFilteredEnvironmentsForDialog();
      }
    });
    this.addToSubscriptionsList(selectedAppSub);
    const userDataSub = this.store.select(userData).subscribe((user: any) => {
      if (user) {
        this.isBetaAccessPrivilegeConsumable = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();
      }
    });
    this.addToSubscriptionsList(userDataSub);
    this.listenForPageChange();
    if (this.isFromModernize) {
      this.getAllScreens();
    }
    this.dataSetMap = this.appGlobalService.get('dataSetMap');
    this.orgId = this.appGlobalService.get('orgId');
    this.appId = this.appGlobalService.get('appId');
    this.textSearch = this.appGlobalService.get('textSearch');
    this.listenLoaderChange();
    const tblNamesSub = this.tableNames$.subscribe((val: any) => {
      this.tableNames = val;
    });
    this.handleAppConnectivityChanges();
    this.subscribeToMergeStatus();
    this.addToSubscriptionsList(tblNamesSub);
    // Subscribe to consumedAPIByProvider for POJO name validation in API Integration
    const consumedAPISub = this.consumedAPIByProvider$.subscribe((data: any) => {
      if (data) {
        this.consumedAPIData = data;
      }
    });
    this.addToSubscriptionsList(consumedAPISub);
    let ignoreValueChanges = false;
    const propDataSub = this.propertiesData$.subscribe((val) => {
      if (!val) {
        return;
      }
      this.formDefaultValues = {};
      this.conditions = {};
      this.conditionalCheck = {};
      this.formGroup = new FormGroup({});
      if (this.formSub) {
        this.formSub.unsubscribe();
      }
      const properties = [...val];
      this.formInfo = [];
      this.allProperties = properties;
      this.betaExpandedGroups = this.getBetaExpandedGroupValues(properties);
      for (const property of properties) {
        if (property?.type === 'group') {
          for (const groupedProperty of property.items) {
            if (groupedProperty?.uiType === 'urlgroup') {
              // Custom URL validators with specific error messages
              const urlValidators = [validateUrl];
              this.environments.forEach((env) => {
                this.formInfo[env.name] = new FormControl(
                  { value: '', disabled: false },
                  { validators: urlValidators, updateOn: 'change' }
                );
                this.conditions[env.name] = groupedProperty.conditionalVisiblity;
              });
            } else if (groupedProperty?.uiType === 'uripath') {
              // Custom URI path validators
              const uriValidators = [this.validateUriPath.bind(this)];
              this.formInfo[groupedProperty.name] = new FormControl(
                { value: '', disabled: property?.disable?.toLowerCase() === 'true' },
                { validators: uriValidators, updateOn: 'change' }
              );
              this.util.checkForDefaultValues(groupedProperty, this.formDefaultValues);
              this.conditions[groupedProperty.name] = groupedProperty.conditionalVisiblity;
            } else {
              this.formInfo[groupedProperty.name] = new FormControl(
                { value: '', disabled: property?.disable?.toLowerCase() === 'true' },
                { updateOn: 'change' }
              );
              this.util.checkForDefaultValues(groupedProperty, this.formDefaultValues);
              if (
                groupedProperty.name === 'enableFieldIds' ||
                groupedProperty.name === 'showFieldIds' ||
                groupedProperty.name === 'enableActions' ||
                groupedProperty.name === 'showActions'
              ) {
                this.formDefaultValues[groupedProperty.name] = [];
              }
              this.conditions[groupedProperty.name] = groupedProperty.conditionalVisiblity;
            }
          }
        } else if (property?.uiType === 'uripath') {
          // Custom URI path validators for non-grouped properties
          const uriValidators = [this.validateUriPath.bind(this)];
          this.formInfo[property.name] = new FormControl(
            { value: '', disabled: property?.disable?.toLowerCase() === 'true' },
            { validators: uriValidators, updateOn: 'change' }
          );
          this.util.checkForDefaultValues(property, this.formDefaultValues);
          this.conditions[property.name] = property.conditionalVisiblity;
        } else {
          this.formInfo[property.name] = new FormControl(
            { value: '', disabled: property?.disable?.toLowerCase() === 'true' },
            { updateOn: 'change' }
          );
          this.util.checkForDefaultValues(property, this.formDefaultValues);
          this.conditions[property.name] = property.conditionalVisiblity;
        }
      }
      this.checkConditionOnValueChange();
      this.formGroup = new FormGroup(this.formInfo);
      // Disable form group if edit is not permitted (e.g., TAG mode)
      if (this.disallowEdit) {
        this.formGroup.disable();
      }
      // Disable allow-editing for auto number on datatype change in datamodel
      if (this.currentClickedField?.type === nodeType.FIELD && this.currentClickedField?.f_type === 'Auto-number') {
        this.formGroup.controls.f_editing?.disable();
      }
      this.formSub = this.formGroup.valueChanges.pipe(distinctUntilChanged()).subscribe((selectedValue) => {
        if (ignoreValueChanges || this.isProcessingValueChange) {
          return;
        }
        this.isProcessingValueChange = true;
        try {
        const valueChange = !this.formGroup?.pristine;

        // onFormLoad are not supporting currently hence commenting below code
        /* let isEventFilled: boolean =
          selectedValue?.lookupConfiguration?.executeOn?.formLoad ||
          selectedValue?.lookupConfiguration?.executeOn?.fieldChange ||
          selectedValue?.lookupConfiguration?.executeOn?.variableChange;
        if (selectedValue?.autoFillLookup) {
          this.formGroup?.get('autoFillLookup')?.disable({ onlySelf: true });
        }
        if (valueChange && selectedValue?.autoFillLookup == true && !isEventFilled) {
          let lookupConfigValue = this.formGroup?.get('lookupConfiguration')?.value;
          if (!lookupConfigValue) {
            lookupConfigValue = {};
          }
          if (!lookupConfigValue?.executeOn) {
            lookupConfigValue.executeOn = {};
          }
          if (lookupConfigValue) {
            const updatedLookupConfig = {
              ...lookupConfigValue,
              executeOn: {
                ...lookupConfigValue?.executeOn,
                formLoad: true
              }
            };

            this.formGroup?.patchValue(
              {
                lookupConfiguration: updatedLookupConfig
              },
              { emitEvent: false }
            );
            this.formGroup?.get('autoFillLookup')?.disable({ onlySelf: true });
          }
        } else if (valueChange && selectedValue?.autoFillLookup === undefined && !isEventFilled) {
          this.formGroup?.get('autoFillLookup')?.enable({ onlySelf: true });
          this.formGroup?.patchValue(
            {
              autoFillLookup: false
            },
            { emitEvent: false }
          );
          ignoreValueChanges = false;
        } else if (valueChange && selectedValue?.autoFillLookup === false && isEventFilled) {
          this.formGroup?.patchValue(
            {
              autoFillLookup: true
            },
            { emitEvent: false }
          );
          this.formGroup?.get('autoFillLookup')?.disable({ onlySelf: true });
        } */

        if (this.formData?.typeChange) {
          this.formData = { ...this.formData, ...this.formGroup?.value, valueChange: valueChange };
          delete this.formData.typeChange;
          this.formGroup?.markAsPristine();
          return;
        }
        this.messageService.clear();
        if (this.formGroup?.pristine) {
          return;
        }
        if (this.appGlobalService.get('ValidateLookupTo')) {
          return;
        }
        if (this.appGlobalService.get('ValidateMultipleVal')) {
          return;
        }
        if (this.currentPage?.currentPage === 'screens') {
          if (this.currentNode !== this.formData?.currentNode) {
            return;
          }
        }
        if (
          this.currentPage?.currentPage === 'screens' &&
          this.currNodeType === 'menuItem' &&
          selectedValue?.customUrl !== null
        ) {
          const customUrlRegex = /^\/[a-zA-Z0-9\-._~%!$&'()*+,;=:@]+/; // NOSONAR
          if (!customUrlRegex.test(selectedValue?.customUrl) && selectedValue?.onClick === 'navigate_to_url') {
            this.showMessage('error', this.translate.instant('CUSTOM_URL'));
            return;
          }
        }
        if (
          this.currentPage?.currentPage === 'screens' &&
          (this.currNodeType === 'menuItem' || this.currNodeType === 'homeTile') &&
          selectedValue?.url != null
        ) {
          const urlRegex =
            // eslint-disable-next-line no-useless-escape
            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/; // NOSONAR
          if (!urlRegex.test(selectedValue?.url) && selectedValue?.onClick === 'open_external_url') {
            this.showMessage('error', this.translate.instant('EXTERNAL_URL'));
            return;
          }
        }
        if (this.fromDataModel && !this.formData) {
          return;
        }
        if (this.currentPage?.currentPage === 'datamodel') {
          if (
            this.currNodeType === nodeType.TABLE &&
            selectedValue?.t_aTableName &&
            this.validateAnalTblNme(selectedValue?.t_aTableName)
          ) {
            this.showMessage('error', 'Duplicate Analytical Table Name');
            return;
          }
          if (this.currNodeType === nodeType.FIELD) {
            if (selectedValue?.f_maxASize > 32) {
              this.showMessage('error', this.translate.instant('MAX_ATTACHMENT_SIZE'));
              return;
            }
            if (selectedValue?.f_aChars) {
              const tolLen = selectedValue?.f_aChars.length;
              if (selectedValue?.f_aChars.charAt(0) === '/' || selectedValue?.f_aChars.charAt(tolLen - 1) === '/') {
                this.showMessage('error', 'Please remove slashes at the beginning and end in the Regex pattern');
                return;
              }
              try {
                const reg = new RegExp(selectedValue?.f_aChars);
              } catch (e) {
                this.showMessage(
                  'error',
                  'Please double-check the provided regular expression syntax.',
                  `<a href='https://www.w3schools.com/jsref/jsref_obj_regexp.asp' target="_blank">Visit Here</a> for more details on the syntax.`
                );
                return;
              }
            }
            if (
              (selectedValue?.f_minL && selectedValue?.f_maxL && selectedValue?.f_minL > selectedValue?.f_maxL) ||
              (selectedValue?.f_maxL === 0 && selectedValue?.f_minL)
            ) {
              this.showMessage('error', 'Minimum length should be less than or equal to Maximum length');
              return;
            }

            try {
              if (selectedValue?.f_aValues) {
                const aValuesObject = JSON.parse(selectedValue?.f_aValues);
                const aValuesArray = aValuesObject?.values;
                if (aValuesArray?.find((a) => a?.name?.length > 256)) {
                  this.showMessage('error', "'Allowed values' can contain only 256 characters");
                  return;
                }
              }
            } catch (e) {
              console.log(e);
            }
            if (
              this.showRdbmsProps &&
              selectedValue?.f_maxL &&
              selectedValue.f_type === 'String' &&
              selectedValue?.f_maxL > 255
            ) {
              this.showMessage('error', 'Maximum Length should not be greater than 255');
              return;
            }

            if (
              this.showRdbmsProps &&
              selectedValue?.f_maxL &&
              selectedValue.f_type === 'Text' &&
              selectedValue.f_maxL > 65535
            ) {
              this.showMessage('error', 'Maximum Length should not be greater than 65535');
              return;
            }

            if (selectedValue?.f_maxFrac > 50 || selectedValue?.f_minFrac > 50) {
              this.showMessage('error', 'Fraction Digits should not be greater than 50');
              return;
            }

            if (
              (selectedValue?.f_minVal &&
                selectedValue?.f_maxVal &&
                selectedValue?.f_minVal > selectedValue?.f_maxVal) ||
              (selectedValue?.f_maxVal === 0 && selectedValue?.f_minVal)
            ) {
              this.showMessage('error', 'Minimum Value should be less than or equal to Maximum Value');
              return;
            }

            if (
              selectedValue.f_hasMultiVal &&
              ((selectedValue?.f_multiValMin &&
                selectedValue?.f_multiValMax &&
                selectedValue?.f_multiValMin > selectedValue?.f_multiValMax) ||
                (selectedValue?.f_multiValMax === 0 && selectedValue?.f_multiValMin))
            ) {
              this.showMessage('error', 'Multiple Values Min should be less than or equal to Multiple Values Max');
              return;
            }

            if (
              (selectedValue?.f_minFrac &&
                selectedValue?.f_maxFrac &&
                selectedValue?.f_minFrac > selectedValue?.f_maxFrac) ||
              (selectedValue?.f_maxFrac === 0 && selectedValue?.f_minFrac)
            ) {
              this.showMessage('error', 'Min Fraction Digits should be less than or equal to Max Fraction Digits');
              return;
            }

            const minDate = new Date(selectedValue.f_minDate),
              maxDate = new Date(selectedValue.f_maxDate);

            if (minDate && minDate > maxDate && selectedValue.f_maxDate != null) {
              this.showMessage(
                'error',
                `The 'Earliest Date' configured for field \`${
                  this.currentClickedField.name
                }\` exceeds the 'Latest Date' setting`
              );
              return;
            } else if (
              selectedValue.f_maxDate &&
              selectedValue.f_maxDate < selectedValue.f_minDate &&
              selectedValue.f_minDate !== null
            ) {
              this.showMessage('error', 'Maximum date cannot be lesser than minimum date');
              return;
            }

            if (
              (selectedValue?.f_minL === 0 || selectedValue?.f_minL) &&
              (this.currentClickedField.name === 'First Name' ||
                this.currentClickedField.name === 'Email' ||
                this.currentClickedField.name === 'Last Name') &&
              selectedValue?.f_maxL &&
              (selectedValue?.f_minL < 1 || selectedValue?.f_maxL > 64)
            ) {
              this.showMessage(
                'error',
                'Minimum Value should not be less than 1 and Maximum Value cannot be greater than 64'
              );
              return;
            }

            if (selectedValue?.f_dVal) {
              if (
                !this.util.isvalidateDMProp(
                  selectedValue,
                  this.formData?.f_type,
                  selectedValue?.f_dVal,
                  'Default Value'
                )
              ) {
                return;
              }
            }
          }
        }
        if (
          this.currentPage?.currentPage === 'datamodel' &&
          this.currNodeType === nodeType.TABLE &&
          selectedValue.t_type !== this.currentpropertiesValues.t_type
        ) {
          let deleteExp = false;
          if (this.formData.t_exportProps) {
            deleteExp = true;
          }
          this.formData = {
            ...this.formDefaultValues,
            ...this.formData,
            ...this.formGroup?.value,
            valueChange: valueChange
          };
          if (deleteExp) {
            delete this.formData.t_exportProps;
          }
          this.formGroup?.markAsPristine();
        } else {
          this.formData = {
            ...this.formDefaultValues,
            ...this.formData,
            ...this.formGroup?.value,
            valueChange: valueChange
          };
        }
        if (this.currentPage?.label === 'API_INTEGRATION' && this.currNodeType === 'api') {
          const hasError = false;
          if (
            this.formGroup?.get('responsePojoName')?.hasError('pattern') &&
            this.formGroup?.get('requestPojoName')?.hasError('pattern')
          ) {
            this.showMessage('error', this.translate.instant('REQUEST_RESPONSE_POJO_PATTERN_ERROR'));
            return;
          } else if (this.formGroup?.get('responsePojoName')?.hasError('pattern')) {
            this.showMessage('error', this.translate.instant('RESPONSE_POJO_PATTERN_ERROR'));
            return;
          } else if (this.formGroup?.get('requestPojoName')?.hasError('pattern')) {
            this.showMessage('error', this.translate.instant('REQUEST_POJO_PATTERN_ERROR'));
            return;
          }

          // Validate that Request POJO name and Response POJO name are not the same
          const requestPojoName = this.formGroup?.get('requestPojoName')?.value;
          const responsePojoName = this.formGroup?.get('responsePojoName')?.value;
          const sameNameValidation = validatePojoNamesNotSame(requestPojoName, responsePojoName);
          if (!sameNameValidation.isValid) {
            this.showMessage(
              'error',
              this.translate.instant(sameNameValidation.errorKey!) || sameNameValidation.errorMessage
            );
            return;
          }

          // Validate that POJO names are unique within the same functional component
          const uniqueValidation = validatePojoNamesUnique(
            requestPojoName,
            responsePojoName,
            this.formData?.sid,
            this.formData?.functionalComponentId,
            this.consumedAPIData
          );
          if (!uniqueValidation.isValid) {
            this.showMessage(
              'error',
              this.translate.instant(uniqueValidation.errorKey!) || uniqueValidation.errorMessage
            );
            return;
          }

          // Validate URI path field
          const urlControl = this.formGroup?.get('url');
          if (urlControl?.hasError('required')) {
            this.showMessage('error', this.translate.instant('URI_IS_MANDATORY'));
            return;
          } else if (urlControl?.invalid) {
            // Check for URI-specific validation errors
            const uriErrorMessage = this.getUriValidationErrorMessage(urlControl);
            this.showMessage('error', uriErrorMessage);
            return;
          }

          // Validate urlgroup fields (Base URL) for provider type
          if (this.currentPage?.label === 'API_INTEGRATION' && this.currNodeType === 'provider') {
            const urlGroupControls = this.environments?.map((env) => this.formGroup?.get(env.name));
            const invalidUrlControl = urlGroupControls?.find((control) => control?.invalid && control?.dirty);
            if (invalidUrlControl) {
              const errorMessage = getUrlValidationErrorMessage(invalidUrlControl, this.translate);
              this.showMessage('error', errorMessage);
              return;
            }
          }

          if (this.formGroup?.get('url')?.hasError('required')) {
            this.showMessage('error', 'URL is mandatory');
            return;
          } else if (this.formGroup?.get('url')?.hasError('pattern')) {
            this.showMessage('error', 'Please enter a valid url');
            return;
          }
        }
        let currFormData = this.formData;
        if (this.currentPage?.currentPage === 'templates') {
          Object.keys(selectedValue)?.forEach((obj) => {
            const propertyName = obj?.substring(0, obj?.length - 6);
            if (typeof selectedValue[obj] === 'object' && `${propertyName}family` === obj) {
              if (typeof selectedValue[obj]?.fontFamily === 'object') {
                currFormData[obj] = selectedValue[obj]?.fontFamily?.name;
              } else {
                currFormData[obj] = selectedValue[obj]?.fontFamily;
              }
              if (typeof selectedValue[obj]?.fontStyle === 'object') {
                currFormData[`${propertyName}style`] = selectedValue[obj]?.fontStyle?.name;
              } else {
                currFormData[`${propertyName}style`] = selectedValue[obj]?.fontStyle;
              }
              if (typeof selectedValue[obj]?.fontWeight === 'object') {
                currFormData[`${propertyName}weight`] = selectedValue[obj]?.fontWeight?.name;
              } else {
                currFormData[`${propertyName}weight`] = selectedValue[obj]?.fontWeight;
              }
              currFormData[`${propertyName}size`] = selectedValue[obj]?.fontSize;
              // currFormData[propertyName + 'color'] = selectedValue[obj]?.fontColor
            }
          });
        }
        if (this.currentPage?.currentPage === 'datamodel' && this.currNodeType === nodeType.FIELD) {
          if (selectedValue.f_aValues) {
            try {
              const vals = (JSON.parse(selectedValue.f_aValues)?.values || []).map((aval) => aval.sid);
              if (
                !vals.includes(currFormData.f_dVal) &&
                currFormData.f_dVal &&
                !currFormData.f_hasMultiVal &&
                currFormData.f_type.toLowerCase() !== 'checkboxgroup'
              ) {
                currFormData.f_dVal = null;
              }
              if (
                (currFormData.f_hasMultiVal || currFormData.f_type.toLowerCase() !== 'checkboxgroup') &&
                currFormData.f_dVal &&
                currFormData.f_dVal.length
              ) {
                const defData = cloneDeep(currFormData.f_dVal);
                for (const ele of defData) {
                  if (!vals.includes(ele)) {
                    const i = currFormData.f_dVal.findIndex((d) => d === ele);
                    currFormData.f_dVal.splice(1, i);
                  }
                }
              }
            } catch (e) {
              console.error(e);
            }
          }
          if (
            !selectedValue.f_lookupTo &&
            (selectedValue.f_lookUpIMap || selectedValue.f_lookUpOMap || selectedValue.f_dField)
          ) {
            currFormData.f_lookUpIMap = null;
            currFormData.f_lookUpOMap = null;
            currFormData.f_dField = null;
            this.additionalCondCheck.f_lookUpIMap = true;
            this.additionalCondCheck.f_lookUpOMap = true;
            this.formGroup?.markAsPristine();
            this.formGroup?.get('f_dField')?.patchValue(null);
            this.clearDisplayFieldSearch();
          }
        }
        if (this.currentPage?.currentPage === 'screens') {
          if (this.currNodeType === 'button') {
            this.applyButtonConfirmationDefaults(currFormData, this.formData);
            // patchvalue in formgroup if there is any change
            if (!isEqual(this.formData, currFormData)) {
              this.formGroup?.patchValue(currFormData, { emitEvent: false });
              this.formGroup?.markAsPristine();
            }
          }
          if (this.currNodeType?.toLowerCase() === 'filterfield') {
            if (
              this.isFromModernize ||
              this.formData?.displayAs?.includes('range') ||
              (!this.formData.enableLookup &&
                this.formData?.fromDefaultFilter &&
                this.formData?.ruleFieldType !== 'custom')
            ) {
              this.formGroup?.controls.enableLookup?.disable({ onlySelf: true });
            } else {
              this.formGroup?.controls.enableLookup?.enable({ onlySelf: true });
            }
            this.toggleDisplayFilter(valueChange, selectedValue, currFormData);
          }
          if (this.currNodeType?.toLowerCase() === 'grid') {
            if (this.formData?.showDetailPageAs === 'as_a_popup' && !this.formData?.detailPagePopupWidth) {
              this.showMessage('error', this.translate.instant('DET_PG_POP_WID'));
              return;
            }
            if (this.formData.sortField) {
              delete this.formData.sortField?.searchable;
              delete this.formData.sortField?.indexed;
            }
            // Handle Row Group and Infinite Scroll conflict
            if (this.handleRowGroupInfiniteScrollConflict(selectedValue, currFormData)) {
              return;
            }
          }
          if (this.currNodeType?.toLowerCase() === 'gridcolumn') {
            this.toggleCustomRender(valueChange, selectedValue, currFormData);
          }
          if (this.currNodeType?.toLowerCase() === 'pageview') {
            if (
              Object.prototype.hasOwnProperty.call(this.formData, 'pageVariablesProperty') &&
              !this.formData.pageVariablesProperty
            ) {
              delete this.formData.pageVariablesProperty;
            }
          }
        }
        if (this.pageName === 'exposedrest' && currFormData.type === 'client') {
          // For sysgen clients, consumers control is disabled so selectedValue.consumers is undefined
          // Preserve existing consumer data to avoid clearing it
          if (!currFormData.sysgen) {
            const currentConsumer = selectedValue.consumers;
            currFormData.consumers = currentConsumer;
            if (currentConsumer) {
              currFormData.consumerApp = {
                appId: currentConsumer.sid,
                contextPath: currentConsumer.contextPath
              };
              currFormData.consumerAppId = currentConsumer.sid;
              currFormData.refAppId = currentConsumer.sid;
            } else {
              currFormData.consumerApp = null;
              currFormData.consumerAppId = null;
              currFormData.refAppId = null;
            }
          }
        }
        // When Exposed To changes, update disabled authentication options accordingly
        if (this.pageName === 'exposedrest' && currFormData.type === 'client') {
          if (selectedValue.exposedTo === 'EXTERNAL') {
            // If KMS was selected, switch to OAUTH2
            if (selectedValue.authenticationType === 'KMS') {
              this.formGroup?.controls.authenticationType?.setValue('OAUTH2', { emitEvent: false });
              currFormData.authenticationType = 'OAUTH2';
            } else {
              currFormData.authenticationType = selectedValue.authenticationType;
            }
            this.disabledRadioOptions['authenticationType'] = ['KMS'];
            // Clear consumer for External
            currFormData.consumerApp = null;
            currFormData.consumerAppId = null;
            currFormData.refAppId = null;
            currFormData.consumers = null;
            currFormData.consumer = null;
            this.formGroup?.controls.consumers?.setValue(null, { emitEvent: false });
          } else if (selectedValue.exposedTo === 'INTERNAL') {
            // If OAuth was selected, switch to KMS
            if (selectedValue.authenticationType === 'OAUTH2') {
              this.formGroup?.controls.authenticationType?.setValue('KMS', { emitEvent: false });
              currFormData.authenticationType = 'KMS';
            } else {
              currFormData.authenticationType = selectedValue.authenticationType;
            }
            this.disabledRadioOptions['authenticationType'] = ['OAUTH2'];
          }
        }
        if (this.pageName === 'consumedrest' && currFormData.type === 'api') {
          currFormData = this.updateApiRequestAndResponseProps(currFormData);
        }

        this.formData = currFormData;
        this.checkForSelfReference(selectedValue);
        } finally {
          this.isProcessingValueChange = false;
        }
      });
      if (this.currentPage?.currentPage === 'datamodel') {
        this.setLookupToListener();
        this.setTableTypeListener();
        this.setMultipleValListener();
        this.setFormulaListener();
        this.setTransientFieldListener();
      }
      this.setFormData();
    });
    this.addToSubscriptionsList(propDataSub);
    this.addToSubscriptionsList(this.formSub);
    const propValueSub = this.propertyPaneValues$
      .pipe(distinctUntilChanged((prev, curr) => prev?.sid === curr?.sid && !curr?.typeChange))
      .subscribe((values) => {
        if (!this.formData || (values && values.sid !== this.formData?.sid)) {
          this.clearFilter();
        }
        if (!this.util.checkEditPermission(this.pageName)) {
          this.disallowEdit = true;
          this.formGroup?.disable();
        }
        if (this.currentPage?.currentPage === 'screens') {
          return;
        } // screens values separate subsction is there
        if (values === 'error') {
          this.showMessage('error', 'Error while accessing the properties');
          values = null;
        }
        this.currentpropertiesValues = {};
        this.currentpropertiesValues = values;

        const isDataModel = this.currentPage?.currentPage === 'datamodel';
        // console.log("Properties", values);
        const isTemplateScreen = this.currentPage?.currentPage === 'templates';
        const isWorkflow = this.currentPage?.currentPage === 'workflow';
        const isScreen = this.currentPage?.currentPage === 'screens';
        if (isTemplateScreen) {
          if (!values?.templateContent) {
            const { sid, valueChange, theme, ...template } = values;
            delete values.valueChange;
            delete values.theme;
            values.templateContent = { ...template };
          }
          values = JSON.parse(values.templateContent);
        }
        const val = cloneDeep(values);
        if (val) {
          this.val = val;
          if (!this.disallowEdit) {
            this.additionalCondCheck.t_hasSoftDelete = true;
            // formgroup.enable triggers formcontrol.valuechanges event, so we need to set onlySelf: true in order to avoid infinite loop
            // still individual formcontrol.valuechanges event will be triggered, so we need to set ignoreValueChanges flag to true
            ignoreValueChanges = true;
            if (val.f_sysF) {
              // EVA-134
              this.formGroup?.disable({ onlySelf: true });
            } else {
              this.formGroup?.enable({ onlySelf: true });
              if (val.f_type) {
                if (val.f_type === 'Auto-number') {
                  this.formGroup?.controls.f_editing?.disable();
                } else if (
                  (val.f_type.toLowerCase() === 'number' ||
                    val.f_type.toLowerCase() === 'double' ||
                    val.f_type.toLowerCase() === 'currency') &&
                  val.f_formula
                ) {
                  // Disable allow-editing for number if f_formula builder is there
                  this.formGroup?.controls.f_editing?.disable();
                  this.additionalCondCheck.f_dVal = true;
                } else {
                  this.additionalCondCheck.f_dVal = false;
                }
              }
            }
            ignoreValueChanges = false;
            if (val.purpose && val.purpose === 'REFERENCE') {
              this.disallowForReference = true;
            } else {
              this.disallowForReference = false;
            }
            if (val.type === 'TABLE') {
              if (val.t_type === 'query_view') {
                this.pickupListService.configurePickupList(val.sid);
              }
            }
            if (val.type === 'FIELD') {
              this.hideOrDisableSpecificPropertiesForDM(val, this.formGroup);
              if (
                !this.showRdbmsProps &&
                (val.f_type === 'String' ||
                  val.f_type === 'URL' ||
                  val.f_type === 'Email' ||
                  val.f_type === 'Dropdown' ||
                  val.f_type === 'Lookup') &&
                !val.f_sysF
              ) {
                this.enableOrDisableMul(val);
              }
            }
            if (this.pageName === 'exposedrest') {
              this.hideOrDisablePropertiesForExposedREST(val);
            }
            if (this.pageName === 'consumedrest') {
              this.addPropertiesForConsumedREST(val);
              this.hideOrDisablePropertiesForConsumedREST(val);
            }
          }
          const backupData = this.formData;
          if (!values?.typeChange) {
            this.formData = null;
            if (this.formGroup) {
              this.formGroup.reset({}, { emitEvent: false });
            }
          }
          if (val?.type === nodeType.TABLE) {
            this.parentTblErrorMsg = '';
            if (val.t_datasetName) {
              if (typeof val.f_lookupTo === 'string') {
                val.t_datasetName = {
                  name: this.getKeyByValue(this.dataSetMap, val.t_datasetName),
                  sid: val.t_datasetName
                };
              }
            }
            if (val.t_pTable) {
              const tbl = filter(this.tableNames, (o) => o.sid === val.t_pTableId);
              if (tbl.length > 0) {
                if (tbl[0]?.name !== val.t_pTable) {
                  val.valueChange = true;
                }
                val.t_pTable = tbl[0];
                this.parentTblErrorMsg = '';
              } else {
                this.parentTblErrorMsg = this.translate.instant('PARENT_TBL_INVALID', { tableName: val.t_pTable });
              }
            }
            if (val.t_type === DMConstants.ANALY_ONLY) {
              if (val.t_transactionalTable && typeof val.t_transactionalTable === 'string') {
                val.t_transactionalTable = {
                  sid: val.t_transactionalTable,
                  name: this.tableIdMap[val.t_transactionalTable]
                };
              }
            }

            if (val.t_type === DMConstants.TRANS_ANALY || val.t_type === DMConstants.ANALY_ONLY) {
              const techSub = this.store.select(technologystackData).subscribe((techStackData: any) => {
                if (techStackData) {
                  this.datasets = [];
                  if (
                    techStackData !== 'newForm' &&
                    techStackData.analyticalDb &&
                    techStackData.analyticalDb === 'Google BigQuery'
                  ) {
                    this.additionalCondCheck.t_datasetName = false;
                    this.dataSetJson = [...(techStackData?.datasets ?? {})];
                    this.datasets = [...this.dataSetJson];
                    // this.datasets = techStackData.datasets ? techStackData.datasets : [];
                    if (val.t_datasetName && typeof val.t_datasetName === 'string' && this.datasets.length) {
                      const setNme = this.dataSetJson.find((dt) => dt.sid === val.t_datasetName);
                      if (setNme) {
                        val.t_datasetName = { name: setNme.name, sid: setNme.sid };
                      } else {
                        val.t_datasetName = null;
                      }
                    } else if (val.t_datasetName && typeof val.t_datasetName === 'string' && !this.datasets.length) {
                      val.t_datasetName = null;
                    }
                    if (techStackData.defaultDataset && !val.t_datasetName) {
                      const defaultNme = this.dataSetJson.find((dt) => dt.sid === techStackData.defaultDataset);
                      val.t_datasetName = { name: defaultNme.name, sid: defaultNme.sid };
                      this.formGroup?.markAsDirty();
                    }
                  } else {
                    this.additionalCondCheck.t_datasetName = true;
                  }
                }
              });
              this.addToSubscriptionsList(techSub);
            }
            const dataSub = this.store.select(picklist).subscribe((pcklst) => {
              if (pcklst) {
                this.pickList = pcklst;
              }
            });
            this.subscriptions.push(dataSub);
          } else if (val?.type === nodeType.FIELD) {
            this.currentClickedField = val;
            if (val.f_fKeyId && typeof val.f_fKeyId === 'string') {
              if (!val.f_fKeyId.includes('f_pTableFId')) {
                val.f_fKeyId = JSON.stringify({ f_fKeyId: val.f_fKeyId, f_pTableFId: val.f_pTableFId });
              }
            }
            if (val.f_lookupTo) {
              if (typeof val.f_lookupTo === 'string' && val.f_lookupType === DMConstants.LOOKUP_TYPE_TABLE) {
                this.appGlobalService.write('lookupToTableId', val.f_lookupTo);
                this.clearDisplayFieldSearch();
                const tbl = filter(this.tableNames, (o) => o.sid === val.f_lookupTo);
                const tbls = filter(this.refTableNames, (o) => o.sid === val.f_lookupTo);
                if (tbl.length > 0) {
                  if (this.applicationType === ApplicationTypes.INDEPENDENT) {
                    val.f_lookupTo = tbl[0];
                  } else {
                    val.f_lookupTo = tbl[0].sid;
                  }
                } else if (tbls.length > 0) {
                  if (this.applicationType === ApplicationTypes.INDEPENDENT) {
                    val.f_lookupTo = tbls[0];
                  } else {
                    val.f_lookupTo = tbls[0].sid;
                  }
                }
                const mandSub = this.store.select(mandatoryFilters).subscribe((data: any) => {
                  if (data) {
                    this.additionalCondCheck.f_lookUpIMap = false;
                  } else if (data === null) {
                    this.additionalCondCheck.f_lookUpIMap = true;
                  }
                });
                this.addToSubscriptionsList(mandSub);
              }
            }
            const syncSub = this.store.select(parentNodeType).subscribe((type: any) => {
              this.parentNodeTableType = type;
              if (type === DMConstants.TRANS_ANALY) {
                // if (!val.f_syncToAnalytical && val.f_type !== 'File Attachments' && val.f_type !== 'Image Carousel') {
                //   val.f_syncToAnalytical = true;
                //   this.formGroup.markAsDirty();
                // }
                if (val.f_type !== 'File Attachments' && val.f_type !== 'Image Carousel') {
                  this.additionalCondCheck.f_hasAnalyticalSync = false;
                } else {
                  this.additionalCondCheck.f_hasAnalyticalSync = true;
                }
              } else {
                this.additionalCondCheck.f_hasAnalyticalSync = true;
              }
            });
            this.addToSubscriptionsList(syncSub);
            if (
              val.f_lookupService &&
              typeof val.f_lookupService === 'string' &&
              val.f_lookupType === DMConstants.LOOKUP_TYPE_WEBSERVICE
            ) {
              const service = this.servivcesList.find((e) => e.sid === val.f_lookupService);
              const serviceObj = {
                name: service.serviceName,
                sid: service.sid,
                tableName: service.tableName,
                tableId: service.tableId
              };
              val.f_lookupService = serviceObj;
            }
            if (val.f_dField) {
              if (typeof val.f_dField === 'string') {
                let dFldName;
                if (this.fieldIdMap[val.f_dField]) {
                  dFldName = this.fieldIdMap[val.f_dField];
                } else {
                  dFldName = this.appGlobalService
                    .get('refAppMetaInfos')
                    .filter((tbl) => tbl.modelId === val.f_dField)[0].name;
                }
                val.f_dField = { sid: val.f_dField, name: dFldName };
              }
            }
            if (val.f_aValues && (val.f_type === 'Date' || val.f_type === 'DateTime')) {
              if (typeof val.f_aValues === 'string') {
                try {
                  const vals = JSON.parse(val.f_aValues);
                  val.f_aValues = vals.values;
                } catch (err) {
                  console.log(err);
                }
              }
            }
            if (val.f_allowedFTypes && typeof val.f_allowedFTypes === 'string') {
              val.f_allowedFTypes = val.f_allowedFTypes.split(',');
            }
            if (val.f_minDate) {
              val.f_minDate = new Date(val.f_minDate);
            }
            if (val.f_maxDate) {
              val.f_maxDate = new Date(val.f_maxDate);
            }
            if (
              val.f_dVal &&
              typeof val.f_dVal !== 'string' &&
              (val.f_type.toLowerCase() === 'date' || val.f_type.toLowerCase() === 'datetime')
            ) {
              try {
                val.f_dVal = new Date(val.f_dVal);
              } catch (e) {
                val.f_dVal = null;
              }
            }
            if (val.f_hasMultiVal) {
              if (val.f_type.toLowerCase() === 'dropdown' || val.f_type.toLowerCase() === 'checkboxgroup') {
                this.additionalCondCheck.f_dVal = false;
              } else {
                this.additionalCondCheck.f_dVal = true;
              }
              this.additionalCondCheck.f_lookUpOMap = true;
            }
          }
          if (val.f_lookupTo) {
            this.additionalCondCheck.f_lookUpOMap = false;
          } else {
            this.additionalCondCheck.f_lookUpOMap = true;
          }
          if (isWorkflow) {
            if (val) {
              let fieldCtrls: any = [];
              let actionCtrls: any = [];
              if (this.currNodeType === 'WorkFlowAction') {
                fieldCtrls = ['mandatoryFieldIds'];
              } else if (this.currNodeType === 'WorkflowActor') {
                fieldCtrls = ['enableFieldIds', 'disableFieldIds', 'showFieldIds', 'hideFieldIds'];
                actionCtrls = ['enableActions', 'disableActions', 'showActions', 'hideActions'];
              }
              fieldCtrls.forEach((ctrl) => {
                if (val[ctrl].includes('*')) {
                  val[ctrl] = this.workflowDynamicOptions.Fields.map((field: any) => {
                    return field.value;
                  });
                }
              });
              actionCtrls.forEach((ctrl) => {
                if (val[ctrl].includes('*')) {
                  val[ctrl] = this.workflowDynamicOptions.Actions.map((action: any) => {
                    return action.value;
                  });
                }
              });
            }
          }
          if (isScreen) {
            if (val) {
              const fieldCtrls = [];
              const actionCtrls = [];
              fieldCtrls.forEach((ctrl) => {
                if (val[ctrl].includes('*')) {
                  val[ctrl] = this.screenDynamicOptions.Fields.map((field: any) => {
                    return field.value;
                  });
                }
              });
            }
          }
          this.formData = val;
          // Add urlgroup form controls for consumed REST providers (if environments are already loaded)
          if (this.pageName === 'consumedrest') {
            this.addUrlGroupFormControls();
          }
          if (!values?.typeChange) {
            this.setFormData();
          } else {
            const diffObj: any = this.util.getDifKeyValObj(backupData, val, [
              'typeChange',
              'sid',
              'createdBy',
              'createdDate',
              'modifiedBy',
              'modifiedDate',
              't_techName',
              't_hasAnalyticalSync',
              't_hasLP',
              't_hasDP',
              't_hasSample',
              't_hasAttachments',
              'tabId'
            ]);
            if (diffObj && Object.keys(diffObj).length) {
              if (diffObj.t_datasetName && !diffObj.t_datasetName?.name) {
                diffObj.t_datasetName = {
                  name: this.getKeyByValue(this.dataSetMap, diffObj.t_datasetName),
                  sid: diffObj.t_datasetName
                };
              }
              this.formGroup?.patchValue(diffObj);
              this.checkConditionOnValueChange();
            } else {
              delete this.formData.typeChange;
            }
            console.log(diffObj);
          }
        } else {
          this.formData = null;
          this.setFormData();
          if (this.formGroup) {
            this.formGroup.reset();
          }
        }
      });
    this.addToSubscriptionsList(propValueSub);

    if (!this.isFromModernize) {
      if (this.applicationType !== ApplicationTypes.INDEPENDENT) {
        this.store.dispatch(
          getTechnologyStackBySuiteId({
            apiConstants: ApiConstants.getTechnologyStackBySuiteId,
            params: {
              suiteid: this.appGlobalService.get('suiteId'),
              shareddbid: this.appGlobalService.get('sharedDbId')
            }
          })
        );
      } else {
        this.store.dispatch(
          getTechnologyStack({
            apiConstants: ApiConstants.getTechnologyStackById,
            appId: this.appId
          })
        );
      }

      const techSubscription = this.bs
        .get(ApiConstants.getTechnologyStackByAppId, { appId: this.appId })
        .subscribe((techStackData) => {
          if (techStackData) {
            this.transactionalDB = techStackData.transactionDb;
            this.techStackData = techStackData;
            this.showRdbmsProps = this.transactionalDB === GlobalConstants.transactionDbRdbms;
          }
        });
      this.addToSubscriptionsList(techSubscription);
    }
    this.suiteId = this.appGlobalService.get('suiteId');

    const allAppsFromSuiteSub = this.store.select(allAppFromSuiteList).subscribe((apps: any) => {
      if (Array.isArray(apps) && apps.length > 0) {
        this.setConsumerApps(apps);
      }
    });
    this.addToSubscriptionsList(allAppsFromSuiteSub);

    const appDataSub = this.store.select(appData).subscribe((app: any) => {
      if (app && app.sid && !this.isMicroserviceSuite) {
        this.setConsumerApps([app]);
      }
    });
    this.addToSubscriptionsList(appDataSub);

    // Subscribe to msScreenData for Member/Suite apps
    const memberScreensSub$ = this.store.select(msScreenData).subscribe((data: any) => {
      if (data) {
        this.memberScreensData = data;
      }
    });
    this.addToSubscriptionsList(memberScreensSub$);
    this.subscriptions.push(memberScreensSub$);
    const appSettSub = this.store.select(appSettingsData).subscribe((val) => {
      if (val) {
        this.settingsData = val;
      }
    });
    this.addToSubscriptionsList(appSettSub);
    const propTypeSub = this.propertiesType$.subscribe((val: any) => {
      const types = [nodeType.FIELD, nodeType.FIELDGROUP, nodeType.GROUP, nodeType.TABLE];
      if (val) {
        this.fromDataModel = types.includes(val);
        this.currNodeType = val;
      }
    });

    this.addToSubscriptionsList(propTypeSub);

    const currSelectedNode = this.propertiesData$.subscribe((val: any) => {
      if (val) {
        this.currentSelectedNode = val.name;
      }
    });
    this.addToSubscriptionsList(currSelectedNode);
    /* For Screens */
    const screenValuesSub = this.screenValues$.pipe(distinctUntilChanged()).subscribe((val: any) => {
      if (!this.formData || (val && val.currentNode !== this.formData?.currentNode)) {
        this.clearFilter();
      }
      // let memApssSub$ = this.store.select(memAppList).subscribe((results: any) => {
      //   if (results) {
      //     this.memApps = results.filter(x => x.sid!==this.appId);
      //   }
      // })
      // this.subscriptions.push(memApssSub$);
      if (val === undefined) {
        return;
      }
      if (!this.util.checkEditPermission(this.pageName)) {
        this.disallowEdit = true;
        this.formGroup?.disable();
      }
      if (val) {
        const dataSub = this.store.select(picklist).subscribe((pcklst) => {
          if (pcklst) {
            this.pickList = pcklst;
            const fieldType = this.pickList?.fieldsWithType
              ?.filter((fld) => this.formData?.currentNode === fld.sid || this.formData?.data === fld.name)[0]
              ?.type?.toLowerCase();
            if (fieldType && this.displayAsFieldsHideOrShow(fieldType)) {
              if (this.conditionalCheck.displayAs) {
                this.conditionalCheck.displayAs = false;
              }
            }
          }
        });
        this.subscriptions.push(dataSub);
        if (val && val.currentNode) {
          this.currentNode = val.currentNode;
        }
        if (val && val.screenValues) {
          if (this.formGroup) {
            this.formGroup.reset({}, { emitEvent: false });
            this.formGroup.markAsPristine();
          }
          this.currentScreenId = val.currentScreen;
          this.formData = { ...val.screenValues, ...{ currentNode: val.currentNode } };
          if (this.currNodeType === 'button') {
            if (this.formData.action === 'call_a_backend_webservice' && this.formData.wfAction) {
              this.hidePropsForWorkflowButtons(val);
            }
            this.applyButtonConfirmationDefaults(this.formData);
            if (this.formData?.pageName) {
              const sc = this.allScreens.find((s) => s.sid === this.formData?.pageName?.sid);
              if (sc?.pageType === 'homePage') {
                this.additionalCondCheck.navigatePageValueMapping = true;
              } else {
                this.additionalCondCheck.navigatePageValueMapping = false;
              }
            }
          }
          if (this.currentScreen?.pageType === 'detail') {
            this.additionalCondCheck.defaultDetailPageEnabled = false;
          } else {
            this.additionalCondCheck.defaultDetailPageEnabled = true;
          }
          const detailPageCtrl = this.formGroup?.get('defaultDetailPageEnabled');
          if (detailPageCtrl) {
            if (this.formData?.defaultDetailPageEnabled && !detailPageCtrl.disabled) {
              detailPageCtrl.disable({ onlySelf: true });
            } else if (!this.formData?.defaultDetailPageEnabled && detailPageCtrl.disabled) {
              detailPageCtrl.enable({ onlySelf: true });
            }
          }
          if (this.currNodeType?.toLowerCase() === 'formfield' && this.formData?.currentNode) {
            const currentFieldDetail = this.currentPicklist?.fieldsWithDetails?.find(
              (f) => f?.sid == this.formData.currentNode
            );

            if (currentFieldDetail) {
              if (currentFieldDetail.f_editing === 'no' || currentFieldDetail.f_editing === 'no') {
                if( this.formGroup?.controls['allowEditing']?.value === 'auto' ) {
                  this.formGroup?.controls['allowEditing']?.disable({ onlySelf: true });
                }
              } else if (!this.disallowEdit) {
                this.formGroup?.controls['allowEditing']?.enable({ onlySelf: true });
              }
            }
          }
        } else if (this.formGroup?.controls['allowEditing'] && this.currNodeType?.toLowerCase() !== 'formfield') {
          if (!this.disallowEdit) {
            this.formGroup?.controls['allowEditing']?.enable({ onlySelf: true });
          }
        }
        if (this.currNodeType?.toLowerCase() === 'filterfield') {
          if (this.currentScreen?.pageTableType === pageTableType.QUERY_VIEW) {
            this.checkforQueryTblMandFilters(val);
          } else {
            this.additionalCondCheck.mandatory = true;
          }
          const currentFieldDetail = this.currentPicklist?.fieldsWithDetails.find((f) => f?.sid === this.currentNode);
          if (currentFieldDetail) {
            if (
              (this.defaultFieldsArray.includes(currentFieldDetail?.name) && currentFieldDetail?.sysGen) ||
              currentFieldDetail?.f_formula
            ) {
              this.formGroup?.controls.holdInPages?.disable();
            } else {
              this.formGroup?.controls.holdInPages?.enable();
            }
          }

          if (this.formData?.fromDefaultFilter) {
            this.formGroup?.controls.fromDefaultFilter?.disable();
            this.formGroup?.controls.displayAs?.disable();
            // disable enable lookup if it is used in DFC and value is also false
            if (!this.formData.enableLookup && this.formData?.ruleFieldType !== 'custom') {
              this.formGroup?.controls.enableLookup?.disable();
            }
          }
          if (this.formData?.displayAs?.includes('range')) {
            this.formGroup?.controls.enableLookup?.disable();
          }
          if (
            this.formData?.mandatory &&
            this.formData?.staticValue &&
            (!Array.isArray(this.formData?.staticValue) ||
              (Array.isArray(this.formData?.staticValue) && this.formData?.staticValue.length))
          ) {
            this.formGroup?.controls.displayAs?.disable();
          }
          // Reset enableLookup to hidden by default; only FK fields and query-view non-FK fields will reveal it.
          // This prevents stale state from a previous FK node bleeding into nodes like captionitem.
          this.additionalCondCheck.enableLookup = true;
        }
        // Reset enableLookup to hidden by default; only FK fields and query-view non-FK fields will reveal it.
        // This prevents stale state from a previous FK node bleeding into nodes like captionitem.
        this.additionalCondCheck.enableLookup = true;
        if (this.formData?.displayAs?.includes('range')) {
          this.formGroup?.controls.enableLookup?.disable();
        } else if (
          ['searchfield', 'filterfield', 'formfield'].includes(this.currNodeType?.toLowerCase()) &&
          this.formData?.type === 'foreignkey'
        ) {
          this.additionalCondCheck.enableLookup = false;
          if (!this.formData?.lookupConfiguration && !this.formData.enableLookup) {
            const fieldType = this.pickList?.fieldsWithType
              ?.find((fld) => this.formData.currentNode === fld.sid || this.formData.data === fld.name)
              ?.type?.toLowerCase();
            if (['radio', 'dropdown', 'auto-number', 'checkbox', 'boolean'].includes(fieldType)) {
              //disable lookup for these types for now,design needed
              this.formGroup?.controls.enableLookup?.disable();
            }
            const foreignkeySub = this.store.select(foreignKeyTbl).subscribe((data: any) => {
              if (!this.formData?.lookupConfiguration && !this.formData.enableLookup) {
                if (data) {
                  if (data.length) {
                    this.additionalCondCheck.enableLookup = false;
                    const foreignKeyids = data
                      ?.filter((dt) => dt.mappings.find((mp) => mp.child === this.currentNode))
                      ?.map((fk) => fk.sid);

                    const ndType = this.currNodeType?.toLowerCase();
                    let treeKey = '';
                    switch (ndType) {
                      case 'captionitem':
                        treeKey = 'detailCaptionBar';
                        break;
                      case 'formfield':
                        treeKey = 'detailForm';
                        break;
                      case 'searchfield':
                        treeKey = 'tableSearch';
                        break;
                      case 'filterfield':
                        treeKey = 'quickFilter';
                        break;
                      default:
                        treeKey = '';
                    }

                    if (treeKey && this.checkForeignKeyUsed(treeKey, foreignKeyids)) {
                      this.formData.enableLookup = false;
                      this.formGroup?.controls.enableLookup?.disable();
                    }
                  }
                  if (foreignkeySub) {
                    foreignkeySub.unsubscribe();
                  }
                }
              } else {
                foreignkeySub.unsubscribe();
              }
            });
            this.addToSubscriptionsList(foreignkeySub);
          }
        } // hide enable lookup if query tables are not there for non foreignkey fields
        else if (
          ['searchfield', 'filterfield', 'formfield'].includes(this.currNodeType?.toLowerCase()) &&
          this.formData?.type !== 'foreignkey'
        ) {
          const queryViewSub = this.store.select(queryTables).subscribe((data: any) => {
            if (data && this.formData?.type !== 'foreignkey') {
              this.qryTable = [...data.filter((d) => d?.tableType === 'query_view')];
              if (this.qryTable?.length) {
                this.additionalCondCheck.enableLookup = false;
              } else {
                this.additionalCondCheck.enableLookup = true;
              }
            }
          });
          this.addToSubscriptionsList(queryViewSub);
        }

        this.setFormData();
        this.updateActiveFiltersVisibility();
        // Disable enable lookup when coming from modernize
        if (this.isFromModernize) {
          this.formGroup?.controls.enableLookup?.disable();
        }
        if (
          this.formData?.mandatory &&
          this.formData?.staticValue &&
          (!Array.isArray(this.formData?.staticValue) ||
            (Array.isArray(this.formData?.staticValue) && this.formData?.staticValue.length))
        ) {
          this.formGroup?.controls.displayAs?.disable();
        }
      }
      // validation for enable lookup
      if (this.currNodeType?.toLowerCase() == 'captionitem') {
        this.additionalCondCheck.enableLookup = true;
      } else if (
        ['searchfield', 'filterfield', 'formfield'].includes(this.currNodeType?.toLowerCase()) &&
        this.formData?.type === 'foreignkey'
      ) {
        this.additionalCondCheck.enableLookup = false;
        if (!this.formData?.lookupConfiguration && !this.formData.enableLookup) {
          const fieldType = this.pickList?.fieldsWithType
            ?.filter((fld) => this.formData.currentNode === fld.sid || this.formData.data === fld.name)[0]
            ?.type?.toLowerCase();
          if (['radio', 'dropdown', 'auto-number'].includes(fieldType)) {
            //disable lookup for these types for now,design needed
            this.formGroup?.controls.enableLookup?.disable();
            if (
              this.formData?.mandatory &&
              this.formData?.staticValue &&
              (!Array.isArray(this.formData?.staticValue) ||
                (Array.isArray(this.formData?.staticValue) && this.formData?.staticValue.length))
            ) {
              this.formGroup?.controls.displayAs?.disable();
            }
          }
          // validation for enable lookup
          const currentdNodeType = this.currNodeType?.toLowerCase();
          const isFieldType = ['searchfield', 'filterfield', 'formfield'].includes(currentdNodeType);
          if (currentdNodeType === 'captionitem') {
            this.additionalCondCheck.enableLookup = true;
          } else if (isFieldType && this.formData?.type === 'foreignkey' && this.formData?.type === 'foreignkey') {
            this.additionalCondCheck.enableLookup = false;
            if (!this.formData?.lookupConfiguration && !this.formData.enableLookup) {
              const fieldType = this.pickList?.fieldsWithType
                ?.find((fld) => this.formData.currentNode === fld.sid || this.formData.data === fld.name)
                ?.type?.toLowerCase();
              if (['radio', 'dropdown', 'auto-number', 'checkbox', 'boolean'].includes(fieldType)) {
                //disable lookup for these types for now,design needed
                this.formGroup?.controls.enableLookup?.disable();
              }
              const foreignkeySub = this.store.select(foreignKeyTbl).subscribe((data: any) => {
                if (!this.formData?.lookupConfiguration && !this.formData.enableLookup) {
                  if (data) {
                    if (data.length) {
                      this.additionalCondCheck.enableLookup = false;
                      const foreignKeyids = data
                        ?.filter((dt) => dt.mappings.find((mp) => mp.child === this.currentNode))
                        ?.map((fk) => fk.sid);

                      const ndType = this.currNodeType?.toLowerCase();
                      let treeKey = '';
                      switch (ndType) {
                        case 'captionitem':
                          treeKey = 'detailCaptionBar';
                          break;
                        case 'formfield':
                          treeKey = 'detailForm';
                          break;
                        case 'searchfield':
                          treeKey = 'tableSearch';
                          break;
                        case 'filterfield':
                          treeKey = 'quickFilter';
                          break;
                        default:
                          treeKey = '';
                      }

                      if (treeKey && this.checkForeignKeyUsed(treeKey, foreignKeyids)) {
                        this.formData.enableLookup = false;
                        this.formGroup?.controls.enableLookup?.disable();
                      }
                    }
                    if (foreignkeySub) {
                      foreignkeySub.unsubscribe();
                    }
                  }
                } else {
                  foreignkeySub.unsubscribe();
                }
              });
              this.addToSubscriptionsList(foreignkeySub);
            }
          } // hide enable lookup if query tables are not there for non foreignkey fields
          else if (
            isFieldType &&
            ['searchfield', 'filterfield', 'formfield'].includes(this.currNodeType?.toLowerCase()) &&
            this.formData?.type !== 'foreignkey'
          ) {
            // Default: hide Lookup group for non-FK fields until we check for query views
            this.additionalCondCheck.enableLookup = true;

            const queryViewSub = this.store.select(queryTables).subscribe((data: any) => {
              if (data && this.formData?.type !== 'foreignkey') {
                this.qryTable = [...data.filter((d) => d?.tableType === 'query_view')];
                if (this.qryTable?.length) {
                  this.additionalCondCheck.enableLookup = false;
                  this.conditionCheckGp['Lookup'] = true;
                } else {
                  this.additionalCondCheck.enableLookup = true;
                  this.conditionCheckGp['Lookup'] = false;
                }
              }
            });
            this.addToSubscriptionsList(queryViewSub);
          }

          this.setFormData();
          this.updateActiveFiltersVisibility();
          if (
            this.currNodeType?.toLowerCase() === 'grid' &&
            this.currentScreen?.pageTableType === pageTableType.QUERY_VIEW
          ) {
            this.additionalCondCheck.defaultFilter = true;
            this.conditionCheckGp['Filter Properties'] = false;
            this.checkforQueryTblMandFilters();
          } else {
            this.additionalCondCheck.defaultFilter = false;
            this.conditionCheckGp['Filter Properties'] = true;
            this.conditionCheckGp['Parameter Mapping'] = false;
          }
        }
      }

      if (this.currNodeType == 'grid' && this.currentScreen?.pageType === 'list') {
        if (this.currentScreen?.pageTableType === 'QUERY_VIEW') {
          this.additionalCondCheck['showTotalCountForQueryView'] = false;
          this.additionalCondCheck['showTotalCountForStandardPages'] = true;
        } else {
          this.additionalCondCheck['showTotalCountForQueryView'] = true;
          this.additionalCondCheck['showTotalCountForStandardPages'] = false;
        }
      } else {
        this.additionalCondCheck['showTotalCountForQueryView'] = true;
        this.additionalCondCheck['showTotalCountForStandardPages'] = true;
      }
    });
    this.addToSubscriptionsList(screenValuesSub);
    const envSub = this.environmentDataList$.subscribe((res: any) => {
      if (res) {
        this.environments = res;
        this.updateFilteredEnvironmentsForDialog();
        this.addUrlGroupFormControls();
      }
    });
    this.addToSubscriptionsList(envSub);
    const possOptionsSub = this.dynamicPossibleOptions$.subscribe((res: any) => {
      if (res) {
        this.workflowDynamicOptions.Fields = res.Fields;
        this.workflowDynamicOptions.Actions = res.Actions;
      }
    });
    this.addToSubscriptionsList(possOptionsSub);
    const possOptionsSubForHide = this.dynamicPossibleOptionsForHide$.subscribe((res: any) => {
      if (res) {
        this.workflowDynamicOptions.Fields = res.Fields;
        this.workflowDynamicOptions.Actions = res.Actions;
      }
    });
    this.addToSubscriptionsList(possOptionsSubForHide);
    const idsSub = this.store.select(allIdMaps).subscribe((res: any) => {
      if (res) {
        if (typeof res.fieldsMap === 'string') {
          this.fieldIdMap = JSON.parse(res.fieldsMap);
          this.tableIdMap = JSON.parse(res.tablesMap);
        } else {
          if (res.fieldsMap && Object.keys(res.fieldsMap).length) {
            this.fieldIdMap = res.fieldsMap;
          }
          if (res.tablesMap && Object.keys(res.tablesMap).length) {
            this.tableIdMap = res.tablesMap;
          }
        }
      }
    });
    this.addToSubscriptionsList(idsSub);
  }

  showParentTableErrorMsg() {
    this.parentTblErrorMsgPopupVisible = !this.parentTblErrorMsgPopupVisible;
  }

  private setConsumerApps(apps: any[]): void {
    const currentAppId = this.appId || this.appGlobalService.get('appId');

    // Detect app switch - clear msApps when switching to a different app
    if (this.previousAppIdForConsumers && this.previousAppIdForConsumers !== currentAppId) {
      this.msApps = [];
    }
    this.previousAppIdForConsumers = currentAppId;

    const sanitized = (apps || []).filter(
      (app) => app && (app.sid || app.appId) && (app.sid || app.appId) !== currentAppId
    );

    // Guard against race condition: don't overwrite valid data with empty array during transient states
    if (sanitized.length === 0 && this.msApps.length > 0) {
      // Keep existing values if incoming is empty but we already have valid data
      // This prevents clearing during app switch race conditions
      return;
    }

    this.msApps = sanitized.map((app) =>
      app.sid
        ? app
        : {
            ...app,
            sid: app.appId
          }
    );
    this.cdr?.detectChanges();
  }

  toggleDisplayFilter(valuechange, selectedValue, currFormData) {
    if (valuechange && Object.prototype.hasOwnProperty.call(this.formGroup?.controls, 'viewInPages')) {
      if (selectedValue?.viewInPages !== null && !this.formGroup?.get('viewInPages')?.pristine) {
        if (selectedValue?.viewInPages) {
          this.disableOrEnableForDisplayFilter('editInPages', true, currFormData, false);
        } else {
          this.disableOrEnableForDisplayFilter('editInPages', true, currFormData, false);
        }
      }
    }
  }

  disableOrEnableForDisplayFilter(formValue, canEnable, currFormData, modfifyFilterInPagesValue) {
    if (canEnable) {
      this.formGroup?.controls[formValue].enable({ onlySelf: true });
    } else {
      this.formGroup?.controls[formValue].disable({ onlySelf: true });
    }
    this.formGroup?.markAsPristine();
    this.formGroup?.controls.editInPages.setValue(false);
    this.formGroup?.markAsPristine();
    currFormData.editInPages = modfifyFilterInPagesValue;
  }

  checkForSelfReference(selectedVal) {
    const checkForFKey =
      this.currentClickedField?.type === nodeType.FIELD &&
      this.currentClickedField?.f_hasFK &&
      selectedVal?.f_mandatory.toLowerCase() === 'yes';
    if (checkForFKey) {
      // Current formgroup values will be fetched after some delay, so setTimeout is included here
      setTimeout(() => {
        const fieldSid = this.currentClickedField?.sid;
        const table: any[] = [];
        this.getTableData(table, this.currentClickedField?.f_tableId, this.dataModelOrders);
        if (table?.[0].data?.t_fKey) {
          const tableId = table[0].key;
          const fks = JSON.parse(table?.[0].data?.t_fKey);
          const hasSelfReference = fks.find(
            (f) => f?.parentTableSid === tableId && f?.mappings.find((m) => m?.child === fieldSid)
          );
          if (hasSelfReference) {
            this.referenceUtil
              .handleWithReferences({
                payload: {
                  modelId: fieldSid,
                  modelType: ModelType.FIELD,
                  actionType: ActionType.FIELD_DELETE,
                  action: UiActions.DELETE
                },
                node: { name: this.formData.name, type: ModelType.FIELD },
                filter: (refs: any[]) => {
                  const filtered = (refs || []).filter((r: any) => r?.propertyName === 'FOREIGN_KEY_FIELDS');
                  this.appGlobalService.write('transientFieldUpdate', filtered.length > 0 ? 'true' : 'false');
                  return filtered;
                },
                onConfirm: () => {
                  // keep selection and proceed
                },
                onNoReferences: () => {
                  this.loader.hide();
                },
                onCancel: () => {
                  this.formGroup?.get('f_mandatory')?.patchValue('no');
                  this.loader.hide();
                },
                onError: () => {
                  this.loader.hide();
                }
              })
              .catch(() => {
                /* ignored */
              });
          } else {
            this.dispatchCall();
          }
        } else {
          this.dispatchCall();
        }
      }, 500);
    } else {
      this.dispatchCall();
    }
  }

  getTableData(table, tableId, dataModelOrders) {
    if (dataModelOrders && dataModelOrders.length > 0) {
      dataModelOrders.forEach((d) => {
        if (d.type === nodeType.TABLE && d.key === tableId) {
          table.push(d);
          return;
        } else if (d.type === nodeType.GROUP) {
          if (d?.children) {
            this.getTableData(table, tableId, d?.children);
          }
        }
      });
    }
  }

  isPrimaryField(node, sid, isPrimaryKey) {
    if (!node) {
      return [];
    }
    node.forEach((nde) => {
      if (!nde.title) {
        return;
      }
      if (nde.type === nodeType.TABLE && nde.data.t_funcPKey && nde.data.t_funcPKey?.includes(sid)) {
        isPrimaryKey = true;
        return;
      } else if (nde.type === nodeType.GROUP) {
        if (nde.children) {
          this.isPrimaryField(nde.children, sid, isPrimaryKey);
        }
      }
    });
    return isPrimaryKey;
  }

  enableOrDisableMul(val) {
    if (this.isPrimaryField(this.dataModelOrders, val.sid, false)) {
      this.primarkeyMsg = `The field ${val.name} is a functional primary key. So it cannot be multiple.`;
      this.formGroup?.controls.f_hasMultiVal?.disable();
    }
  }


  hidePropsForWorkflowButtons(val) {
    this.formGroup?.controls.action?.disable();
    this.formGroup?.controls.service?.disable();
    this.additionalCondCheck.visibility = true;
    this.additionalCondCheck.buttonEnabled = true;
  }

  hideOrDisablePropertiesForExposedREST(val) {
    this.disabledRadioOptions = {};
    if (val.sysgen) {
      this.formGroup?.disable();
      if (val.type === 'client') {
        // Re-enable authenticationType so user can switch between KMS and Service Account
        this.formGroup?.controls.authenticationType?.enable();
        // Disable OAuth 2.0 when Internal is selected
        const exposedTo = this.formGroup?.controls?.exposedTo?.value || val.exposedTo;
        if (!val.rtWorkflow && !val.rtBusinessRule) {
          if (exposedTo === 'INTERNAL') {
            this.disabledRadioOptions['authenticationType'] = ['OAUTH2'];
          } else if (exposedTo === 'EXTERNAL') {
            this.disabledRadioOptions['authenticationType'] = ['KMS'];
          }
        }
      }
    } else if (val.type === 'client') {
      if (this.appGlobalService.get('applicationType') === ApplicationTypes.INDEPENDENT) {
        this.formGroup?.controls.exposedTo.disable();
      }
      // Disable auth options based on exposedTo
      const exposedToValue = this.formGroup?.controls?.exposedTo?.value || val.exposedTo;
      if (exposedToValue === 'INTERNAL') {
        this.disabledRadioOptions['authenticationType'] = ['OAUTH2'];
      } else if (exposedToValue === 'EXTERNAL') {
        this.disabledRadioOptions['authenticationType'] = ['KMS'];
      }
    }

    this.refreshBetaRadioOptions();
  }


  isRadioOptionDisabled(propertyName: string, optionValue: string): boolean {
    return this.disabledRadioOptions[propertyName]?.includes(optionValue) ?? false;
  }

  private refreshBetaRadioOptions(): void {
    if (!Array.isArray(this.allProperties)) {
      return;
    }

    this.betaRadioOptionsMap = {};

    const processProperty = (property: any) => {
      if (!property || property.uiType !== 'radiobutton' || !Array.isArray(property.possibleValues)) {
        return;
      }

      const options = property.possibleValues.map((option: any) => ({
        label: this.getPropertyValue(option?.name, property?.name),
        value: option?.value,
        disabled: this.isRadioOptionDisabled(property?.name, option?.value)
      }));

      this.betaRadioOptionsMap[property.name] = options;
    };

    this.allProperties.forEach((property: any) => {
      if (property?.type === 'group' && Array.isArray(property.items)) {
        property.items.forEach((item: any) => processProperty(item));
      } else {
        processProperty(property);
      }
    });
  }

  hideOrDisablePropertiesForConsumedREST(val) {
    this.formGroup?.enable({ emitEvent: false });
    // Hide Domain URLs property immediately for sysgen providers (no delay)
    if (val.sysgen && val?.type?.toLowerCase() === 'provider') {
      this.additionalCondCheck.baseUrl = true;
    } else {
      this.additionalCondCheck.baseUrl = false;
    }
    // Clear any pending timeout to prevent race conditions when switching between
    // system-generated and user-created nodes
    if (this.consumedRestTimeoutId !== null) {
      clearTimeout(this.consumedRestTimeoutId);
      this.consumedRestTimeoutId = null;
    }
    this.consumedRestTimeoutId = setTimeout(() => {
      if (val.sysgen) {
        if (val?.type?.toLowerCase() === 'api') {
          this.formGroup?.disable({ emitEvent: false });
          this.formGroup?.controls.remarks.enable({ emitEvent: false });
        } else if (val?.type?.toLowerCase() === 'provider') {
          this.formGroup?.disable({ emitEvent: false });
          this.formGroup?.controls.remarks.enable({ emitEvent: false });
        }
      } else {
        if (val?.type?.toLowerCase() === 'api') {
          if (val.httpMethod === 'GET') {
            this.formGroup?.controls.requestMediaType.disable({ emitEvent: false });
            this.formGroup?.controls.requestPojoName.disable({ emitEvent: false });
          }
          if (val?.requestMediaType === 'NONE') {
            this.formGroup?.controls.requestPojoName.disable({ emitEvent: false });
          }
          if (val?.responseMediaType === 'NONE') {
            this.formGroup?.controls.responsePojoName.disable({ emitEvent: false });
          }
        }

        if (val.authenticationType === 'rappit_intra_communication' || val.authenticationType === 'rappit_intra_communication_kms') {
          this.formGroup?.disable({ emitEvent: false });
          this.formGroup?.controls.remarks.enable({ emitEvent: false });
        }
      }
      // Mark form as pristine after initial setup to prevent spurious save
      this.formGroup?.markAsPristine();
    }, 100);
  }

  addPropertiesForConsumedREST(val) {
    this.formGroup?.enable({ emitEvent: false });
    if (val?.type?.toLowerCase() === 'api') {
      this.formGroup?.controls.requestPojoName?.setValidators([
        Validators.pattern(/^(?![A-Z]+$)[A-Z][a-z0-9_]*([A-Z][a-z0-9_]*)*$/) //NOSONAR
      ]);
      this.formGroup?.controls.responsePojoName?.setValidators([
        Validators.pattern(/^(?![A-Z]+$)[A-Z][a-z0-9_]*([A-Z][a-z0-9_]*)*$/) //NOSONAR
      ]);
      // for system  generated fields only uri path will be appended
      if (!val.sysgen) {
        this.formGroup?.controls.url?.setValidators([
          Validators.required,
          Validators.pattern(
            /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$|^www\.[^\s/$.?#].[^\s]*$|^[a-zA-Z][a-zA-Z0-9+.-]*:[^\s]+$/
          ) //NOSONAR
        ]);
      } else {
        this.formGroup?.controls.url?.setValidators([Validators.required]);
      }

      // URI path validator for API sub-paths (must start with '/')
      this.formGroup?.controls.url?.setValidators([Validators.required, this.validateUriPath.bind(this)]);

      this.formGroup?.controls.requestPojoName?.updateValueAndValidity({ emitEvent: false });
      this.formGroup?.controls.responsePojoName?.updateValueAndValidity({ emitEvent: false });
      this.formGroup?.controls.url?.updateValueAndValidity({ emitEvent: false });
    }
  }

  checkForQueryView(val) {
    this.dataModelOrders.forEach((tbl) => {
      if (tbl.type === nodeType.TABLE && tbl.data.sid === val.f_tableId && tbl.data.t_type === 'query_view') {
        this.queryCheck = true;
      } else if (tbl.type === nodeType.GROUP) {
        const qCheck = false;
        this.iterate(tbl, val, qCheck);
        if (qCheck) {
          return;
        }
      } else if (tbl.type === nodeType.TABLE && tbl.data.sid === val.f_tableId && tbl.data.t_type !== 'query_view') {
        this.queryCheck = false;
        return;
      }
    });
    return this.queryCheck;
  }
  iterate(tbl, val, qcheck) {
    if (tbl.type === nodeType.TABLE && tbl.data.sid === val.f_tableId && tbl.data.t_type === 'query_view') {
      this.queryCheck = true;
      qcheck = true;
      return;
    } else if (tbl.type === nodeType.GROUP) {
      if (tbl?.children) {
        tbl?.children.forEach((tb: any) => {
          this.iterate(tb, val, false);
        });
      }
    } else if (tbl.type === nodeType.TABLE && tbl.data.sid === val.f_tableId && tbl.data.t_type !== 'query_view') {
      this.queryCheck = false;
      qcheck = true;
      return;
    }
  }
  hideOrDisableSpecificPropertiesForDM(val, formGroup) {
    this.isQueryTable = false;
    if (
      this.applicationType !== ApplicationTypes.MEMBER &&
      this.dataModelOrders.filter((fld) => fld.title === 'Application User')[0]?.data?.sid !== val?.f_tableId &&
      !val?.f_sysF
    ) {
      this.additionalCondCheck.f_mandatory = false;
      this.additionalCondCheck.f_maxL = false;
      this.additionalCondCheck.f_minL = false;
      this.additionalCondCheck.f_dVal = false;
      this.additionalCondCheck.f_aValues = false;
      this.additionalCondCheck.f_aChars = false;
      this.additionalCondCheck.f_regError = false;
      // this.formGroup?.controls['f_searchable']?.enable();
      this.additionalCondCheck.f_hasMultiVal = false;
      this.formGroup?.controls.f_mandatory?.enable();
      this.additionalCondCheck.f_transientField = false;
      this.conditionCheckGp.Multivalue = true;
      this.conditionCheckGp.Mandatory = true;
      this.conditionCheckGp.Length = true;
      this.conditionCheckGp['Character Validation'] = true;
      this.formGroup?.controls.f_hasMultiVal?.enable();
      if (
        !(
          val.f_type === 'Auto-number' ||
          ((val.f_type.toLowerCase() === 'number' ||
            val.f_type.toLowerCase() === 'double' ||
            val.f_type.toLowerCase() === 'currency') &&
            val.f_formula)
        )
      ) {
        this.formGroup?.controls.f_editing?.enable();
      }
      this.formGroup?.controls.f_view?.enable();
      if (this.checkForQueryView(val)) {
        this.conditionCheckGp.Technical = false;
        this.conditionCheckGp['Field Value Reference'] = false;
        this.queryViewArray.forEach((q) => {
          this.additionalCondCheck[q] = true;
        });
        this.isQueryTable = true;
      } else {
        this.conditionCheckGp.Technical = true;
        this.checkForTechnical();
        this.conditionCheckGp['Field Value Reference'] = true;
        this.queryViewArray.forEach((q) => {
          this.additionalCondCheck[q] = false;
        });
        this.isQueryTable = false;
      }
      return;
    }
    let funcKeysSid: any = [];
    switch (val.name) {
      case 'First Name':
        this.additionalCondCheck.f_regError = false;
        if (val.sysGen) {
          this.additionalCondCheck.f_maxL = false;
          this.additionalCondCheck.f_aChars = false;
          this.additionalCondCheck.f_regError = false;
          this.additionalCondCheck.f_minL = false;
          this.additionalCondCheck.f_mandatory = false;
          this.additionalCondCheck.f_dVal = true;
          this.additionalCondCheck.f_hasMultiVal = true;
          this.formGroup?.controls.f_mandatory?.disable();
          this.additionalCondCheck.f_transientField = true;
          this.conditionCheckGp.Multivalue = false;
        }
        break;
      case 'Last Name':
        if (val.sysGen) {
          this.additionalCondCheck.f_maxL = false;
          this.additionalCondCheck.f_minL = false;
          this.additionalCondCheck.f_aChars = false;
          this.additionalCondCheck.f_regError = false;
          this.additionalCondCheck.f_mandatory = false;
          this.additionalCondCheck.f_dVal = true;
          this.additionalCondCheck.f_hasMultiVal = true;
          this.formGroup?.controls.f_mandatory?.disable();
          this.additionalCondCheck.f_transientField = true;
          this.conditionCheckGp.Multivalue = false;
        }
        break;
      case 'Email':
        if (val.sysGen) {
          this.additionalCondCheck.f_maxL = false;
          this.additionalCondCheck.f_minL = false;
          this.additionalCondCheck.f_aChars = false;
          this.additionalCondCheck.f_regError = false;
          this.additionalCondCheck.f_mandatory = false;
          this.additionalCondCheck.f_dVal = true;
          this.additionalCondCheck.f_hasMultiVal = true;
          // this.formGroup?.controls['f_searchable']?.enable();
          this.formGroup?.controls.f_mandatory?.disable();
          this.additionalCondCheck.f_transientField = true;
          this.conditionCheckGp.Multivalue = false;
        }
        break;
      case 'User Roles':
        if (val.sysGen) {
          this.additionalCondCheck.f_maxL = true;
          this.additionalCondCheck.f_minL = true;
          this.additionalCondCheck.f_mandatory = true;
          this.additionalCondCheck.f_aChars = true;
          this.additionalCondCheck.f_regError = true;
          this.additionalCondCheck.f_transientField = true;
          this.additionalCondCheck.f_hasMultiVal = false;
          this.formGroup?.controls.f_hasMultiVal?.disable();
          this.formGroup?.controls.f_editing?.disable();
          this.formGroup?.controls.f_view?.disable();
          this.conditionCheckGp.Mandatory = false;
          this.conditionCheckGp.Length = false;
          this.conditionCheckGp['Character Validation'] = false;
        }
        break;
      case GlobalConstants.isActiveField:
        {
          this.formGroup?.controls.f_editing?.enable();
          this.formGroup?.controls.f_view?.enable();
          this.formGroup?.controls.f_viewC?.enable();
          this.formGroup?.controls.f_editC?.enable();
          // this.formGroup?.controls['f_searchable']?.disable();
          this.additionalCondCheck.f_transientField = true;
          this.formGroup?.controls.f_mandatory?.enable();
          this.formGroup?.controls.f_helpText?.enable();
          this.formGroup?.controls.f_infoBubble?.enable();
          this.formGroup?.controls.remark?.enable();
        }
        break;
      default:
        if (!val.f_sysF || (val.f_sysF && !this.defaultFieldsArray.includes(val.name))) {
          this.additionalCondCheck.f_mandatory = false;
          this.additionalCondCheck.f_maxL = false;
          this.additionalCondCheck.f_minL = false;
          this.additionalCondCheck.f_dVal = false;
          this.additionalCondCheck.f_aValues = false;
          this.additionalCondCheck.f_aChars = false;
          this.additionalCondCheck.f_regError = false;
          if (val.f_type === 'Auto-number') {
            this.formGroup?.controls.f_editing?.disable();
          }
          this.additionalCondCheck.f_hasMultiVal = false;
          this.formGroup?.controls.f_mandatory?.enable();
          this.additionalCondCheck.f_transientField = false;
          this.conditionCheckGp.Multivalue = true;
          this.conditionCheckGp.Mandatory = true;
          this.conditionCheckGp.Length = true;
          this.conditionCheckGp['Character Validation'] = true;
          this.formGroup?.controls.f_hasMultiVal?.enable();
          this.formGroup?.controls.f_view?.enable();
          if (this.dataModelOrders.filter((fld) => fld.data.sid === val.f_tableId)[0]?.data?.t_funcPKey === null) {
            this.additionalCondCheck.f_transientField = false;
          } else {
            funcKeysSid = [
              ...(this.dataModelOrders.find((fld) => fld.data.sid === val.f_tableId)?.data?.t_funcPKey?.split(',') ??
                [])
            ];
            if (funcKeysSid.includes(val.sid)) {
              this.additionalCondCheck.f_transientField = true;
            } else {
              this.additionalCondCheck.f_transientField = false;
            }
          }
          if ((val.name === 'Pid' || val.name === 'Sid') && val.f_sysF) {
            this.formGroup?.disable();
            this.formGroup?.controls.f_editing?.enable();
            this.formGroup?.controls.f_maxL?.enable();
          } else if (val.name === 'Language Code' && val.f_sysF) {
            this.formGroup?.disable();
            this.additionalCondCheck.f_aValues = true;
          } else if (val.name === 'Sync Time' && val.f_sysF) {
            this.formGroup?.disable();
            this.formGroup?.controls.f_label?.enable();
          }
        } else {
          this.formGroup?.controls.f_hasMultiVal?.disable();
          this.formGroup?.controls.f_editing?.disable();
          this.formGroup?.controls.f_view?.disable();
          this.formGroup?.controls.f_mandatory?.disable();
        }
        break;
    }
  }

  checkCondition(operator, field, value) {
    let condition;
    switch (operator) {
      case '=':
      case '==':
      case '===':
        condition = field === value;
        break;
      case '!=':
      case '!==':
        condition = field !== value;
        break;
      case 'isPresent':
        condition = field;
        break;
      default:
        condition = false;
    }
    return condition;
  }

  checkVisibility(property) {
    //only for screens
    if (!property?.conditionalVisiblity || property.conditionalVisiblity.length === 0) {
      return false;
    }
    const length = property.conditionalVisiblity.length;
    if (length > 0) {
      const conditionStatisfied = true;
      for (let i = 0; i < length; i++) {
        const condition = property.conditionalVisiblity[i];
        const fieldVal = this.formGroup?.get(condition.field)?.value;
        if (this.checkCondition(condition.operator, String(fieldVal), condition.value)) {
          return true;
        }
      }
    }
    return false;
  }

  getOptions(property) {
    if (property.includes(',')) {
      return property.split(',');
    }
    property = camelCase(property);
    const value = this.formGroup?.get(property)?.value;
    if (!value) {
      return [];
    }
    if (typeof value === 'string') {
      const val = JSON.parse(value);
      return val?.values || [];
    } else if (value === 'object') {
      return value?.values || [];
    }
    return [];
  }

  getFieldName() {
    if (this.currNodeType === nodeType.FIELD) {
      return this.formData?.name;
    }
  }

  clearFilter() {
    this.searchTerm = '';
  }

  setColorChange(obj) {
    if (!obj?.name) {
      return;
    }
    this.formGroup?.markAsDirty();
    const tempFormData = { ...this.formData };
    this.allProperties.forEach((property) => {
      if (property?.name === obj.name) {
        tempFormData[property.name] = obj.color;
        this.formDefaultValues[property.name] = obj.color;
      }
      if (property?.type === 'group') {
        for (const groupedProperty of property.items) {
          // Below code will not Change reference variable values when Primary or Secondary color values changing
          if (groupedProperty?.uiType === 'colorpicker' && obj.name === groupedProperty.name) {
            tempFormData[groupedProperty.name] = obj.color;
            this.formDefaultValues[groupedProperty.name] = obj.color;
          }
          // End
        }
      }
    });
    this.formData = { ...tempFormData };
    this.formGroup?.patchValue(this.formData);
  }

  resetToDefaultValues(individualProperty: any = '') {
    this.formGroup?.markAsDirty();
    const tempFormData = { ...this.formData };
    let fontGroupName: any = '';
    this.allProperties.forEach((property) => {
      if (property?.type === 'group') {
        for (const groupedProperty of property.items) {
          if (individualProperty) {
            // Changing reference variable values when Primary or Secondary color values changing(*Commented for now)
            // if (groupedProperty.name===individualProperty?.name || (individualProperty?.name==="$primary-color" && (individualProperty?.defaultValue?.toLowerCase()===groupedProperty.defaultValue?.toLowerCase())) || (individualProperty?.name==="$secondary-color" && (individualProperty?.defaultValue?.toLowerCase()===groupedProperty.defaultValue?.toLowerCase()))) {
            // End
            // Below code will not Change reference variable values when Primary or Secondary color values changing
            if (groupedProperty.name === individualProperty?.name) {
              // End
              tempFormData[groupedProperty.name] = groupedProperty.defaultValue;
              const obj = individualProperty?.name;
              const propertyName = obj?.substring(0, obj?.length - 6);
              if (`${propertyName}family` === obj) {
                const styleObj = property.items?.filter((styleOb) => styleOb?.name === `${propertyName}style`);
                tempFormData[`${propertyName}style`] = styleObj[0]?.defaultValue;
                const weightObj = property.items?.filter((weightOb) => weightOb?.name === `${propertyName}weight`);
                tempFormData[`${propertyName}weight`] = weightObj[0]?.defaultValue;
                const sizeObj = property.items?.filter((sizeOb) => sizeOb?.name === `${propertyName}size`);
                tempFormData[`${propertyName}size`] = sizeObj[0]?.defaultValue;

                fontGroupName = propertyName;
              }
            }
          } else {
            tempFormData[groupedProperty.name] = groupedProperty.defaultValue;
            const obj = groupedProperty?.name;
            const propertyName = obj?.substring(0, obj?.length - 6);
            if (`${propertyName}family` === obj) {
              setTimeout(() => {
                const fontComponentRef: any = this.fontComponents
                  ?.toArray()
                  ?.filter((ob) => ob?.element?.name === `${propertyName}family`);
                fontComponentRef[0]?.triggerFormChanges(propertyName, this.formData);
              }, 100);
            }
          }
        }
      } else if (property?.name) {
        if (individualProperty) {
          // Changing reference variable values when Primary or Secondary color values changing(*Commented for now)
          // if (property?.name===individualProperty?.name || (individualProperty?.name==="$primary-color" && (individualProperty?.defaultValue?.toLowerCase()===property?.defaultValue?.toLowerCase())) || (individualProperty?.name==="$secondary-color" && (individualProperty?.defaultValue?.toLowerCase()===property?.defaultValue?.toLowerCase()))) {
          // End
          // Below code will not Change reference variable values when Primary or Secondary color values changing
          if (property?.name === individualProperty?.name) {
            // End
            tempFormData[property?.name] = property?.defaultValue;
          }
        } else {
          tempFormData[property?.name] = property?.defaultValue;
        }
      }
    });
    this.formData = { ...tempFormData };
    this.formGroup?.patchValue(this.formData);
    if (fontGroupName) {
      const fontComponentRef: any = this.fontComponents
        ?.toArray()
        ?.filter((obj) => obj?.element?.name === `${fontGroupName}family`);
      fontComponentRef[0]?.triggerFormChanges(fontGroupName, this.formData);
    }
  }

  getMenuOptions(option: any = '', propertyGroup: any) {
    if (option === 'resetAll') {
      this.menuItems = [
        {
          label: 'Reset All Properties',
          icon: 'pi pi-undo',
          command: () => {
            this.resetToDefaultValues('');
          }
        }
      ];
    } else if (option) {
      let isDisabled = option?.defaultValue?.toLowerCase() === this.formData[option?.name]?.toLowerCase();
      if (option?.name?.indexOf('font-family') >= 0) {
        const propertyName = option?.name?.substring(0, option?.name?.length - 6);
        if (`${propertyName}family` === option?.name) {
          const styleObj = propertyGroup?.filter((styleOb) => styleOb?.name === `${propertyName}style`);
          const weightObj = propertyGroup?.filter((weightOb) => weightOb?.name === `${propertyName}weight`);
          const sizeObj = propertyGroup?.filter((sizeOb) => sizeOb?.name === `${propertyName}size`);

          isDisabled =
            isDisabled &&
            styleObj[0]?.defaultValue?.toLowerCase() === this.formData[`${propertyName}style`]?.toLowerCase() &&
            weightObj[0]?.defaultValue?.toLowerCase() === this.formData[`${propertyName}weight`]?.toLowerCase() &&
            sizeObj[0]?.defaultValue?.toLowerCase() === this.formData[`${propertyName}size`]?.toLowerCase();
        }
      }
      this.menuItems = [
        {
          label: 'Reset to Default Value',
          icon: 'pi pi-undo',
          disabled: isDisabled,
          command: () => {
            this.resetToDefaultValues(option);
          }
        }
      ];
    }
  }

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }

  isPropertyNotFontGroup(property: any) {
    if (
      property &&
      property?.toLowerCase()?.indexOf('font-family') < 0 &&
      (property?.toLowerCase()?.indexOf('font-size') >= 0 ||
        property?.toLowerCase()?.indexOf('font-weight') >= 0 ||
        property?.toLowerCase()?.indexOf('font-style') >= 0)
    ) {
      return false;
    }
    return true;
  }

  getPropertyTitle(name) {
    if (name && name?.toLowerCase().indexOf('family') >= 0 && this.currentPage?.currentPage === 'templates') {
      const subString = name?.toLowerCase()?.split('family')[0];
      const splitedFontFamilyName = name?.substr(0, subString.length);
      return splitedFontFamilyName;
    } else if (this.currentPage?.currentPage === 'screens' && name === 'Default Filter Applied') {
      if (this.formData?.addedFromDefaultFilter) {
        return this.translate.instant('ADD_DEF_FIL');
      }
      return this.translate.instant('UPD_DEF_FIL');
    } else if (this.currentPage?.currentPage === 'screens' && name === 'Auto') {
      if (this.settingsData?.displayFilterIn === 'QUICK_FILTER') {
        return this.translate.instant('QUICK_FILTER');
      } else if (this.settingsData?.displayFilterIn === 'HIDE_FILTER') {
        return this.translate.instant('HIDE_FILTER');
      }

      return this.translate.instant('TABLE_SETTINGS');
    }

    return name;
  }

  getPropertyValue(name, propertyName) {
    if (name && name?.toLowerCase().indexOf('family') >= 0 && this.currentPage?.currentPage == 'templates') {
      const subString = name?.toLowerCase()?.split('family')[0];
      const splitedFontFamilyName = name?.substr(0, subString.length);
      return splitedFontFamilyName;
    } else if (propertyName == 'displayFilterIn' && this.currentPage?.currentPage == 'screens' && name == 'Auto') {
      // Only for Active/Inactive Filter's "Position on Page" property
      if (this.settingsData?.displayFilterIn == 'QUICK_FILTER') {
        return this.translate.instant('QUICK_FILTER');
      } else if (this.settingsData?.displayFilterIn == 'HIDE_FILTER') {
        return this.translate.instant('HIDE_FILTER');
      }
      return this.translate.instant('TABLE_SETTINGS');
    }

    return name;
  }

  removeConfirmationDetailPage(propertyName) {
    if (propertyName !== 'detailPage') {
      this.clearAutoCompleteData(propertyName);
      return;
    }
    const confirmDeleteCallback = () => {
      this.clearAutoCompleteData(propertyName);
    };
    this.confirmationDialogService.confirm({
      message: this.translate.instant('REMOVE_DETAIL_PAGE_CONFIRMATION'),
      accept: confirmDeleteCallback,
      reject: () => {
        return;
      }
    });
  }

  clearAutoCompleteData(propertyName) {
    if (this.formGroup) {
      this.formGroup.value.propertyName = null;
      this.formGroup.value.f_lookUpOMap = null;
      this.formGroup.markAsDirty();
    }
    const formControl = this.formGroup?.get([propertyName]) as FormControl;
    const formControlOMap = this.formGroup?.get(['f_lookUpOMap']) as FormControl;
    formControl?.setValue(null);
    formControlOMap?.setValue(null);
    this.store.dispatch(propertyActions.clearLookUp({ clear: true }));
  }

  clearVal(event, property) {
    const pName = property?.name;
    if (pName && this.formDefaultValues[pName]) {
      this.formGroup?.markAsDirty();
      this.formGroup?.get(pName)?.patchValue(this.formDefaultValues[pName]);
    }
  }

  validateAnalTblNme(name) {
    return this.dataModelOrders.find((node) => {
      if (!node.title) {
        return false;
      }
      if (
        node.type === nodeType.TABLE &&
        node.data.t_aTableName === name &&
        node.data.sid !== this.currentpropertiesValues.sid
      ) {
        return true;
      } else if (node.type === nodeType.GROUP) {
        if (node.children) {
          return node.children.find(
            (ele) => ele.data.t_aTableName === name && ele.data.sid !== this.currentpropertiesValues.sid
          );
        }
      }
      return false;
    });
  }

  ngOnDestroy(): void {
    //Auto UnSubscribe needed
    // Clear any pending consumed REST timeout to prevent memory leaks
    if (this.consumedRestTimeoutId !== null) {
      clearTimeout(this.consumedRestTimeoutId);
      this.consumedRestTimeoutId = null;
    }
    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(setScreenValues({ screenValues: null }));
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
    this.store.dispatch(propertyActions.setPropertiesType({ propertiesType: null }));
  }

  onTemplateChange(templateProps) {
    // Include mandatory and optional filters in the template change payload
    const enhancedTemplateProps = {
      ...templateProps,
      t_mandatory_filters: this.currentTable?.t_mandatory_filters || [],
      t_optional_filters: this.currentTable?.t_optional_filters || []
    };
    this.templateValueChange.emit(enhancedTemplateProps);
  }

  onSelectSearableFields(_event: any, _property) {
    if (
      this.allFields.length > 0 &&
      !Object.values(this?.allFields).some((value: any) => value?.sid === _event?.value?.sid) &&
      this.techStackData.textSearch === GlobalConstants.searchDbEs
    ) {
      // Prevent selection of the disabled item
      this.formGroup?.get(_property.name)?.reset();
      _event.preventDefault();
      return;
    }
  }

  processOption(name, options) {
    if (name === 'sortField') {
      const arr: any = [];
      options?.forEach((o: any) => {
        if (
          [
            'Checkboxgroup',
            'Radio',
            'File Attachments',
            'Image Carousel',
            'Lookup',
            'Checkbox',
            'Color',
            'Yes No',
            'Complex Datatype'
          ].indexOf(o.f_type) < 0
        ) {
          arr.push(o);
        }
      });
      return arr;
    }
    return options || [];
  }

  /**
   * Check if a node has a buttonGroup ancestor by walking up the parent chain
   * Stops at actionBar or when no more parents exist
   * @param node - The tree node to check
   * @returns true if buttonGroup is found in ancestry
   */
  private hasButtonGroupAncestor(node: any): boolean {
    if (!node) {
      return false;
    }

    let currentParent = node.parent;
    while (currentParent) {
      const parentType = currentParent.type?.toLowerCase();

      // Stop at actionBar
      if (parentType === 'actionbar') {
        return false;
      }

      // Found buttonGroup in ancestry
      if (parentType === 'buttongroup') {
        return true;
      }

      // Move up to next parent
      currentParent = currentParent.parent;
    }

    return false;
  }

  /**
   * Get possibleValues for a property, filtering buttonType for buttons inside buttonGroup
   * Only executed for button nodes to avoid performance overhead
   * @param property - The property definition
   * @returns Filtered or original possibleValues
   */
  getPossibleValues(property: any): any[] {
    if (!property?.possibleValues) {
      return [];
    }

    // Only filter for buttonType property when current node is a button
    if (
      this.currNodeType?.toLowerCase() === 'button' &&
      property.name === 'buttonType'
    ) {
      // Check if button has buttonGroup ancestor
      if (this.hasButtonGroupAncestor(this.currentSelectedTreeNode)) {
        // Return only Icon Only option
        return property.possibleValues.filter((option: any) => option.value !== 'icon_only');
      }
    }

    return property.possibleValues;
  }

  updateApiRequestAndResponseProps(val: any) {
    if (val?.requestMediaType !== 'NONE') {
      this.formGroup?.controls.requestPojoName.enable({ onlySelf: true });
    } else {
      this.formGroup?.controls.requestPojoName.disable({ onlySelf: true });
      if (this.formGroup?.controls.requestPojoName.value) {
        this.formGroup?.controls.requestPojoName.setValue('');
      }
      val.requestPojoName = '';
    }
    if (val?.responseMediaType !== 'NONE') {
      this.formGroup?.controls.responsePojoName.enable({ onlySelf: true });
    } else {
      this.formGroup?.controls.responsePojoName.disable({ onlySelf: true });
      if (this.formGroup?.controls.responsePojoName.value) {
        this.formGroup?.controls.responsePojoName.setValue('');
      }
      val.responsePojoName = '';
    }
    return val;
  }
  /**
   *
   * @param event - Event emitted from business rules config component
   * This method is used to update the business rules enabled state in properties pane
   */
  onBusinessRulesConfigChanged(event: { isEnabled: boolean }) {
    this.isBusinessRulesEnabled = event.isEnabled;
  }

  getQvValidation(type: 'queryValidation' | 'paramValidation'): string {
    try {
      const parsed = JSON.parse(this.formData?.qvErrorMessages);
      return parsed?.[type] || '';
    } catch {
      return '';
    }
  }

  getQvTooltip(): string {
    const queryVal = this.getQvValidation('queryValidation');
    const paramVal = this.getQvValidation('paramValidation');
    const parts: string[] = [];
    if (queryVal) {
      parts.push(queryVal);
    }
    if (paramVal) {
      parts.push(paramVal);
    }
    return parts.join('\n');
  }

  /**
   * Handle QV error icon click to show table validation
   */
  onQvErrorIconClick(event: any) {
    event.stopPropagation();
    this.showTableValidation();
  }

  /**
   * Add form controls for urlgroup properties when environments are loaded after properties
   * Only applies to "Webservices Consumed From" Provider node properties
   */
  addUrlGroupFormControls() {
    // Only add urlgroup controls for consumed REST provider nodes
    if (this.pageName !== 'consumedrest' || this.formData?.type?.toLowerCase() !== 'provider') {
      return;
    }
    if (!this.allProperties || !this.environments || this.environments.length === 0) {
      return;
    }
    // Custom URL validators with specific error messages
    const urlValidators = [validateUrl];
    for (const property of this.allProperties) {
      if (property?.type === 'group') {
        for (const groupedProperty of property.items) {
          if (groupedProperty?.uiType === 'urlgroup') {
            this.environments.forEach((env) => {
              if (!this.formGroup?.contains(env.name)) {
                const control = new FormControl(
                  { value: '', disabled: false },
                  { validators: urlValidators, updateOn: 'change' }
                );
                this.formGroup?.addControl(env.name, control);
                this.conditions[env.name] = groupedProperty.conditionalVisiblity;
              }
            });
          }
        }
      }
    }
    this.checkConditionOnValueChange();
    // Re-patch form data values for environment URLs
    if (this.formData) {
      const envValues = {};
      this.environments.forEach((env) => {
        if (this.formData[env.name] !== undefined) {
          envValues[env.name] = this.formData[env.name];
        }
      });
      if (Object.keys(envValues).length > 0) {
        this.formGroup?.patchValue(envValues, { emitEvent: false });
      }
    }
  }

  /**
   * Get filtered environments for Domain URL configuration display
   * Based on app type:
   * - Independent: use all environments
   * - Suite App: use environments with sharedDbId as "none" or doesn't exist
   * - Member: use all environments
   */
  getFilteredEnvironments(): any[] {
    if (!this.environments || this.environments.length === 0) {
      return [];
    }
    // Only filter for Suite apps
    if (this.applicationType === ApplicationTypes.SUITE) {
      return this.environments.filter((env: any) => !env.sharedDbId || env.sharedDbId === 'none');
    }
    // For Independent and Member apps, use all environments
    return this.environments;
  }

  /**
   * Update the cached filtered environments for the dialog
   * Call this when environments or applicationType changes
   */
  updateFilteredEnvironmentsForDialog(): void {
    this.filteredEnvironmentsForDialog = this.getFilteredEnvironments();
  }

  /**
   * Get count of filtered environments for Domain URL configuration display
   */
  getFilteredEnvCount(): number {
    return this.getFilteredEnvironments().length;
  }

  /**
   * Get count of configured environment URLs
   * @returns Number of environments with non-empty URL values
   */
  getConfiguredEnvCount(): number {
    const filteredEnvs = this.getFilteredEnvironments();
    if (filteredEnvs.length === 0) {
      return 0;
    }
    let count = 0;
    filteredEnvs.forEach((env) => {
      const value = this.formGroup?.get(env.name)?.value;
      if (value && value.trim() !== '') {
        count++;
      }
    });
    return count;
  }

  /**
   * Open the Provider Environment URL configuration dialog
   * Provides sorting, filtering, and bulk editing capabilities for environment URLs
   */
  openProviderEnvUrlConfig(): void {
    this.updateFilteredEnvironmentsForDialog();
    this.envFormDataCache = this.getEnvFormData();
    this.showEnvUrlConfigDialog = true;
  }

  /**
   * Get current form data for environments
   */
  getEnvFormData(): Record<string, string> {
    const formData: Record<string, string> = {};
    this.environments.forEach((env: any) => {
      const value = this.formGroup?.get(env.name)?.value;
      formData[env.name] = value || '';
    });
    return formData;
  }

  /**
   * Handle save from environment URL config dialog
   */
  onEnvUrlConfigSave(envData: Record<string, string>): void {
    Object.keys(envData).forEach((envName) => {
      const control = this.formGroup?.get(envName);
      if (control) {
        control.setValue(envData[envName], { emitEvent: true });
        control.markAsDirty();
      }
    });
    this.formGroup?.markAsDirty();
  }

  /**
   * Custom URI path validator that validates sub-paths for API endpoints
   * @param control - The form control to validate
   * @returns ValidationErrors or null
   */
  validateUriPath(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Allow empty values (will be caught by required validator if mandatory)
    if (!value || value.trim() === '') {
      return null;
    }

    const trimmedValue = value.trim();

    // Check if URI starts with forward slash (not allowed)
    if (trimmedValue.startsWith('/')) {
      return { uriMustNotStartWithSlash: true };
    }

    // Check for whitespace in the middle
    if (/\s/.test(trimmedValue)) {
      return { uriContainsWhitespace: true };
    }

    // Check for double slashes
    if (/\/\//.test(trimmedValue)) {
      return { uriDoubleSlash: true };
    }

    // Check for invalid characters (only allow alphanumeric, -, _, /, ., {, }, ?, &, =)
    const validUriPattern = /^[a-zA-Z0-9\-_/.{}?&=]+$/; //NOSONAR
    if (!validUriPattern.test(trimmedValue)) {
      return { uriInvalidCharacters: true };
    }

    // Check for path after query params (not allowed)
    if (trimmedValue.includes('?')) {
      const queryIndex = trimmedValue.indexOf('?');
      const afterQuery = trimmedValue.substring(queryIndex + 1);
      if (afterQuery.includes('/')) {
        return { uriPathAfterQueryParams: true };
      }
    }

    // Check that path segments are valid (no empty segments except trailing)
    const segments = trimmedValue.split('/');
    for (let i = 0; i < segments.length; i++) {
      // Allow empty segment only if it's the last one (trailing slash)
      if (segments[i] === '' && i !== segments.length - 1) {
        return { uriEmptySegment: true };
      }
    }

    return null;
  }

  /**
   * Get specific error message based on URI validation error type
   * @param control - The form control with validation errors
   * @returns The appropriate error message
   */
  getUriValidationErrorMessage(control: AbstractControl | null): string {
    if (!control) {
      return '';
    }
    if (control.hasError('uriMustNotStartWithSlash')) {
      return this.translate.instant('URI_MUST_NOT_START_WITH_SLASH');
    }
    if (control.hasError('uriContainsWhitespace')) {
      return this.translate.instant('URI_CONTAINS_WHITESPACE');
    }
    if (control.hasError('uriDoubleSlash')) {
      return this.translate.instant('URI_DOUBLE_SLASH');
    }
    if (control.hasError('uriInvalidCharacters')) {
      return this.translate.instant('URI_INVALID_CHARACTERS');
    }
    if (control.hasError('uriEmptySegment')) {
      return this.translate.instant('URI_EMPTY_SEGMENT');
    }
    if (control.hasError('uriPathAfterQueryParams')) {
      return this.translate.instant('URI_PATH_AFTER_QUERY_PARAMS');
    }
    return this.translate.instant('URI_INVALID');
  }

  formulaBuilderErrorStatus: 'error' | 'warning' | 'none' = 'none';
  onStatusChange(status: 'error' | 'warning' | 'none') {
    this.formulaBuilderErrorStatus = status;
  }

  /**
   * Shows table validation dialog using pre-validation-tbl-view component
   */
  showTableValidation() {
    if (!this.formData?.sid) {
      this.util.showError(this.translate.instant('TABLE_NOT_FOUND'));
      return;
    }

    this.callTableValidationApi(false);
  }

  /**
   * Call table validation API with prevalidation support
   * @param ignoreWarnings Whether to ignore warnings and proceed
   */
  callTableValidationApi(ignoreWarnings: boolean) {
    this.zone.run(() => {
      this.isLoadingProps = true;
    });

    // Prepare API URL with sid in path and ignoreWarnings parameter
    const url = `${ApiConstants.getTableValidationData.url}/${this.formData.sid}?ignoreWarnings=${ignoreWarnings}`;
    const apiObj = { ...ApiConstants.getTableValidationData, ...{ url: url } };

    // Call the backend method to get validation data
    this.bs.get(apiObj, {}).subscribe({
      next: (response: any) => {
        this.zone.run(() => {
          this.isLoadingProps = false;

          if (response) {
            // Handle PREVALIDATIONS similar to CUD config
            if (response.PREVALIDATIONS) {
              const err = response.PREVALIDATIONS;

              const preValmodal = this.dialogService.open(PreValidationTblViewComponent, {
                showHeader: false,
                styleClass: 'reference-tree',
                modal: true,
                data: {
                  prevalidationList: {
                    preValicationList: err,
                    type: 'qvTableValidation'
                  }
                }
              });

              const sub = preValmodal.onClose.subscribe((data: any) => {
                if (data) {
                  // User clicked continue - call API again with ignoreWarnings = true
                  this.callTableValidationApi(true);
                }
              });

              this.addToSubscriptionsList(sub);
            } else if (response.error) {
              // Handle error case
              this.util.showError(this.translate.instant('TABLE_VALIDATION_ERROR'));
            }
          }
        });
      },
      error: (error) => {
        console.error('Error fetching table validation data:', error);
        this.zone.run(() => {
          this.isLoadingProps = false;
          this.util.showError(this.translate.instant('TABLE_VALIDATION_ERROR'));
        });
      }
    });
  }
}

